// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* GLOBAL */
body {
    background-color: white !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type='number'] {
    -moz-appearance: textfield;
}

::-webkit-scrollbar {
    width: 8px !important;
}

::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #ddd !important;
}

::-webkit-scrollbar-thumb {
    background: #ddd !important;
    border-radius: 4px !important;
}

.MuiTableContainer-root::-webkit-scrollbar {
    height: 8px !important;
}

.ft-blueText {
    color: #3367d6 !important;
}

.ft-redText {
    color: #d32f2f !important;
}

.ft-lineBreak {
    white-space: pre-line;
}

.ft-move {
    cursor: move;
}

.ft-moving {
    opacity: 0.2;
}

.ft-iconWarning {
    color: #ed6c02;
}

.ft-breakWord {
    overflow-wrap: break-word;
}

.ft-search fieldset {
    border-color: white !important;
}

.ft-search label,
.ft-search input,
.ft-search svg {
    color: white !important;
}

.ft-select-box {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

/* LOCALE */
.ft-locale-check {
    color: green;
    margin-left: 8px;
    font-size: 12px !important;
}

/* EDITOR */
.ft-editor {
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 0 0 4px 4px;
    border-top: none;
    padding: 16px 14px;
    min-height: 128px;
    position: relative;
    overflow: hidden;
}

.ft-editor figure img[style*="float: right"] {
  margin-left: 20px;
}

.ft-editor figure img[style*="float: left"] {
  margin-right: 20px;
}

.ft-editorButtonContainer {
    color: rgba(0, 0, 0, 0.54);
    width: fit-content;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 4px 4px 0 0;
    background-color: #ffffff;
}

.ft-editorTextTypeContainer {
    position: relative;
}

.ft-editorTextType {
    margin-top: 3px !important;
    min-width: 150px;
}

.ft-editorTextTypeOption {
    cursor: pointer;
    margin: 8px;
}

.ft-editorTextTypeOptionContainer {
    padding: 8px;
    position: absolute;
    background-color: white;
    top: 41px;
    left: 0;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    z-index: 2;
    min-width: max-content;
}

.ft-editorActive {
    color: black !important;
    background-color: #eeeeee !important;
    border-radius: 0 !important;
}

.ft-editorLinkContainer {
    padding: 16px;
    position: absolute;
    background-color: white;
    top: 41px;
    left: -175px;
    width: 500px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    z-index: 1;
}

.ft-editorPaletteColorContainer {
    padding-bottom: 8px;
    position: absolute;
    background-color: white;
    top: 48px;
    left: 0;
    width: 250px !important;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    z-index: 2;
}

.ft-editorPaletteColor {
    border-radius: 4px;
    width: 16px;
    height: 16px;
    cursor: pointer;
}

.ft-editorPaletteBlack {
    background-color: #000000;
}

.ft-editorPaletteDarkGray4 {
    background-color: #434343;
}

.ft-editorPaletteDarkGray3 {
    background-color: #666666;
}

.ft-editorPaletteDarkGray2 {
    background-color: #999999;
}

.ft-editorPaletteDarkGray1 {
    background-color: #b7b7b7;
}

.ft-editorPaletteGray {
    background-color: #cccccc;
}

.ft-editorPaletteLightGray1 {
    background-color: #d9d9d9;
}

.ft-editorPaletteLightGray2 {
    background-color: #efefef;
}

.ft-editorPaletteLightGray3 {
    background-color: #f3f3f3;
}

.ft-editorPaletteWhite {
    background-color: #ffffff;
}

.ft-editorPaletteRedBerry {
    background-color: #980000;
}

.ft-editorPaletteRed {
    background-color: #ff0000;
}

.ft-editorPaletteOrange {
    background-color: #ff9900;
}

.ft-editorPaletteYellow {
    background-color: #ffff00;
}

.ft-editorPaletteGreen {
    background-color: #00ff00;
}

.ft-editorPaletteCyan {
    background-color: #00ffff;
}

.ft-editorPaletteCornflowerBlue {
    background-color: #4a86e8;
}

.ft-editorPaletteBlue {
    background-color: #0000ff;
}

.ft-editorPalettePurple {
    background-color: #9900ff;
}

.ft-editorPaletteMagenta {
    background-color: #ff00ff;
}

.ft-editorPaletteLightRedBerry3 {
    background-color: #e6b8af;
}

.ft-editorPaletteLightRed3 {
    background-color: #f4cccc;
}

.ft-editorPaletteLightOrange3 {
    background-color: #fce5cd;
}

.ft-editorPaletteLightYellow3 {
    background-color: #fff2cc;
}

.ft-editorPaletteLightGreen3 {
    background-color: #d9ead3;
}

.ft-editorPaletteLightCyan3 {
    background-color: #d0e0e3;
}

.ft-editorPaletteLightCornflowerBlue3 {
    background-color: #c9daf8;
}

.ft-editorPaletteLightBlue3 {
    background-color: #cfe2f3;
}

.ft-editorPaletteLightPurple3 {
    background-color: #d9d2e9;
}

.ft-editorPaletteLightMagenta3 {
    background-color: #ead1dc;
}

.ft-editorPaletteLightRedBerry2 {
    background-color: #dd7e6b;
}

.ft-editorPaletteLightRed2 {
    background-color: #ea9999;
}

.ft-editorPaletteLightOrange2 {
    background-color: #f9cb9c;
}

.ft-editorPaletteLightYellow2 {
    background-color: #ffe599;
}

.ft-editorPaletteLightGreen2 {
    background-color: #b6d7a8;
}

.ft-editorPaletteLightCyan2 {
    background-color: #a2c4c9;
}

.ft-editorPaletteLightCornflowerBlue2 {
    background-color: #a4c2f4;
}

.ft-editorPaletteLightBlue2 {
    background-color: #9fc5e8;
}

.ft-editorPaletteLightPurple2 {
    background-color: #b4a7d6;
}

.ft-editorPaletteLightMagenta2 {
    background-color: #d5a6bd;
}

.ft-editorPaletteLightRedBerry1 {
    background-color: #cc4125;
}

.ft-editorPaletteLightRed1 {
    background-color: #e06666;
}

.ft-editorPaletteLightOrange1 {
    background-color: #f6b26b;
}

.ft-editorPaletteLightYellow1 {
    background-color: #ffd966;
}

.ft-editorPaletteLightGreen1 {
    background-color: #93c47d;
}

.ft-editorPaletteLightCyan1 {
    background-color: #76a5af;
}

.ft-editorPaletteLightCornflowerBlue1 {
    background-color: #6d9eeb;
}

.ft-editorPaletteLightBlue1 {
    background-color: #6fa8dc;
}

.ft-editorPaletteLightPurple1 {
    background-color: #8e7cc3;
}

.ft-editorPaletteLightMagenta1 {
    background-color: #c27ba0;
}

.ft-editorPaletteDarkRedBerry1 {
    background-color: #a61c00;
}

.ft-editorPaletteDarkRed1 {
    background-color: #cc0000;
}

.ft-editorPaletteDarkOrange1 {
    background-color: #e69138;
}

.ft-editorPaletteDarkYellow1 {
    background-color: #f1c232;
}

.ft-editorPaletteDarkGreen1 {
    background-color: #6aa84f;
}

.ft-editorPaletteDarkCyan1 {
    background-color: #45818e;
}

.ft-editorPaletteDarkCornflowerBlue1 {
    background-color: #3c78d8;
}

.ft-editorPaletteDarkBlue1 {
    background-color: #3d85c6;
}

.ft-editorPaletteDarkPurple1 {
    background-color: #674ea7;
}

.ft-editorPaletteDarkMagenta1 {
    background-color: #a64d79;
}

.ft-editorPaletteDarkRedBerry2 {
    background-color: #85200c;
}

.ft-editorPaletteDarkRed2 {
    background-color: #990000;
}

.ft-editorPaletteDarkOrange2 {
    background-color: #b45f06;
}

.ft-editorPaletteDarkYellow2 {
    background-color: #bf9000;
}

.ft-editorPaletteDarkGreen2 {
    background-color: #38761d;
}

.ft-editorPaletteDarkCyan2 {
    background-color: #134f5c;
}

.ft-editorPaletteDarkCornflowerBlue2 {
    background-color: #1155cc;
}

.ft-editorPaletteDarkBlue2 {
    background-color: #0b5394;
}

.ft-editorPaletteDarkPurple2 {
    background-color: #351c75;
}

.ft-editorPaletteDarkMagenta2 {
    background-color: #741b47;
}

.ft-editorPaletteDarkRedBerry3 {
    background-color: #5b0f00;
}

.ft-editorPaletteDarkRed3 {
    background-color: #660000;
}

.ft-editorPaletteDarkOrange3 {
    background-color: #783f04;
}

.ft-editorPaletteDarkYellow3 {
    background-color: #7f6000;
}

.ft-editorPaletteDarkGreen3 {
    background-color: #274e13;
}

.ft-editorPaletteDarkCyan3 {
    background-color: #0c343d;
}

.ft-editorPaletteDarkCornflowerBlue3 {
    background-color: #1c4587;
}

.ft-editorPaletteDarkBlue3 {
    background-color: #073763;
}

.ft-editorPaletteDarkPurple3 {
    background-color: #20124d;
}

.ft-editorPaletteDarkMagenta3 {
    background-color: #4c1130;
}

.ft-editorCustomButton {
    width: fit-content !important;
    font-size: 18px !important;
    font-weight: bold !important;
}

.ft-underline {
    text-decoration: underline;
}

.ft-bold {
    font-weight: bold;
}

.ft-hide {
    display: none !important;
}

.ft-map {
    width: 100% !important;
    height: 100% !important;
}

.ft-pictureProgress {
    background-color: inherit !important;
    box-shadow: none !important;
}

.ft-pictureProgressHelper {
    text-align: center !important;
    color: white !important;
    margin-top: 8px !important;
}

.ft-opaqueImage {
    opacity: 0.2;
}

.ft-organisation-info-value {
    color: #757575 !important;
    font-size: 0.8rem !important;
}

.ft-organisation-edit-info-button {
    visibility: hidden;
    cursor: pointer;
}

.ft-organisation-info-container:hover .ft-organisation-edit-info-button {
    visibility: visible;
}
.ft-organisation-info-container {
    padding-top: 0 !important;
}

.ft-organisation-column{
    height: calc(100vh - 64px) !important;
    overflow-y: scroll;
}

.ft-organisation-tab-content {
    height: calc(100% - 49px);
    padding: 0 !important;
    overflow-y: auto;
}

.ft-organisation-tab-container {
    display: grid;
    height: 100%;
    width: 100%;
    grid-template-rows: 52px minmax(0, 1fr)
}

.ft-organisation-tab-container-activity{
    display: flex;
    height: 100%;
    width: 100%;
}
.ft-organisation-modal{
    position: absolute;
    width: 40vw;
    /* max-height: 20vw; */
    z-index: 2;
    bottom: 25px
}

.ft-organisation-list-item-detail {
    width: 100%;
    padding: 3px;
    display: grid;
    grid-template-columns: minmax(0, 1fr) 40px;
    align-items: center;
    padding: 5px 20px;
    cursor: pointer;
}

.ft-organisation-contact {
    width: 100%;
    padding: 10px ;
    border: solid 1px #efefef;
    border-radius: 5px;
    display: grid;
    grid-template-columns: minmax(0, 1fr) 40px;
    align-items: flex-start;
}

.ft-organisation-list-item-edit-icon {
    display: none;
}

.ft-organisation-list-item-detail:hover {
    background-color: #c0e0ff;
    border: solid 1px #1976d2;
    border-radius: 10px;
}

.ft-organisation-contact:hover .ft-organisation-list-item-edit-icon {
    display: block;
    cursor: pointer;
    padding: 0px 10px;
}

.ft-organisation-list-item-detail:hover .ft-organisation-list-item-edit-icon {
    display: block;
    cursor: pointer;
    padding: 0px 10px;
}
.ft-organisation-item-paper{
    width: 100%;
    padding: 16px;
    margin-bottom: 10px
}

.ft-organisation-item-delete-icon {
    opacity: 0;
    cursor: pointer;
}

.ft-organisation-item-paper:hover .ft-organisation-item-delete-icon {
    opacity: 1;
}

.ft-organisation-form-edit {
    gap: 7px;
    display: flex;
    flex-direction: column;
    width: 100%;
}

.ft-organisation-modal-header {
    max-height: 55px !important;
    min-height: 55px !important;
    height: 55x;
}

.ft-organisation-logo-container {
    display: flex;
    align-items: center;
    flex-direction: column !important;
}
.ft-organisation-logo-text{
    display: none;
    font-size: 1rem;
    color: #1976d2
}
.ft-organisation-logo-container:hover .ft-organisation-logo-text{
    display:block;
}

.ft-organisation-logo-input{
    opacity:0;
    position: absolute;
    height:60px;
    width:60px;
    cursor:pointer
}
.ft-organisation-download-input{
    display:none;
    position: fixed;
    height:24px;
    width:24px;
    cursor:pointer;
}
.ft-organisation-rubric{
    margin-bottom: 5px !important;
    border-bottom: solid 1px rgba(0, 0, 0, 0.12);
    ;
}

.ft-organisation-rubric-header-icon {
    opacity: 0;
    cursor: move;
    /* fallback if grab cursor is unsupported */
    cursor: grab;
    cursor: -moz-grab;
    cursor: -webkit-grab;
    height: 24px;
    width: 19px;
    transition: none !important;
    will-change: opacity;
}

.ft-organisation-rubric-header:hover .ft-organisation-rubric-header-icon {
    opacity: 1
}
.ft-organisation-rubric-header{
    min-height: 0 !important;
}
.ft-rotate180 {
    transform: rotate(180deg);
}

.ft-padding {
    padding: 16px !important;
}

.ft-marginTop8 {
    margin-top: 8px !important;
}

.ft-list-root {
    width: 100% !important;
    transition: width 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms !important;
}

.ft-list-rootShift {
    width: calc(100% - 300px) !important;
    transition: width 225ms cubic-bezier(0, 0, 0.2, 1) 0ms !important;
}

.ft-bottomBar {
    top: auto !important;
    bottom: 0;
    background-color: white !important;
    color: black !important;
    width: 100% !important;
    transition: width 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms !important;
}

.ft-bottomBarShift {
    width: calc(100% - 240px) !important;
    transition: width 225ms cubic-bezier(0, 0, 0.2, 1) 0ms !important;
}

.ft-list-paper {
    position: relative !important;
    padding-top: 8px !important;
}

.ft-list-title {
    font-size: 18px !important;
    font-weight: bold !important;
    margin-bottom: 16px !important;
}

.ft-list-table {
    min-width: 750px !important;
}

.ft-list-listHeaderContainer {
    padding-left: 8px !important;
    padding-right: 4px !important;
}

.ft-list-listTitle {
    flex: 1 1 100% !important;
}

.ft-list-blueTextButton {
    text-transform: initial !important;
    color: #3367d6 !important;
}

.ft-listColumnConfigurator-columnContainer {
    position: absolute !important;
    z-index: 6 !important;
    max-height: 60vh;
    overflow: auto;
}

.ft-listColumnConfigurator-title {
    padding: 16px !important;
}

.ft-listColumnConfigurator-column {
    padding: 0 16px !important;
    cursor: grab;
}

.ft-listColumnConfigurator-lastUpdated {
    background-color: #eeeeee;
}

.ft-listColumnConfigurator-iconOffset {
    margin-right: 48px !important;
}

.ft-deleteButton {
    color: #3367d6 !important;
    margin: 0 24px 16px 24px !important;
}

.ft-newTabIcon {
    margin-left: 8px;
    vertical-align: text-bottom;
    font-size: 18px !important;
}

.ft-list {
    cursor: pointer;
}

.ft-listRow-seen {
    background-color: #eeeeee;
    box-shadow: inset 4px 0 0 0 #3367d6;
    -webkit-box-shadow: inset 4px 0 0 0 #3367d6;
    -moz-box-shadow: inset 4px 0 0 0 #3367d6;
}

.ft-listRow-suspended td {
    color: #cccccc !important;
}

.ft-listRow-name {
    color: #3367d6 !important;
    cursor: pointer !important;
}

.ft-listRow-no-price {
    color: rgb(100, 100, 100) !important;
}


.ft-listRow-name:hover {
    text-decoration: underline !important;
}

.ft-listRow-description {
    max-width: 300px;
    max-height: 2.8em;   /* filet de sécurité : 2 lignes de 1.4em, cf. max_lines */
    overflow: hidden;
    cursor: pointer;
}

/* Aperçu de liste : on conserve les retours à la ligne enregistrés, un bloc = une ligne,
   tronquée par une ellipsis. Les blocs vides sont retirés en amont (mode compact). */
.ft-listRow-description p,
.ft-listRow-description li,
.ft-listRow-description blockquote,
.ft-listRow-description h1,
.ft-listRow-description h2,
.ft-listRow-description h3,
.ft-listRow-description h4,
.ft-listRow-description h5,
.ft-listRow-description h6 {
    margin: 0;
    font-size: inherit;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ft-listRow-button {
    text-transform: inherit !important;
}

.ft-listRow-menuItem {
    padding: 16px !important;
}

.ft-listRow-checkbox {
    width: 74px;
}

.ft-listHead-minWidth {
    min-width: 256px !important;
}

.ft-listHead-fixedWidth {
    width: 144px !important;
    overflow-wrap: break-word;
}
.ft-listHead-big {
    text-transform: uppercase;
    color: #4A75DA !important;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
}
.ft-listHead-other-big {
    text-transform: uppercase;
    color: white !important;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
}

.ft-provisions-background {
    background-color: #E59215 !important
}
.ft-invoices-background {
    background-color: #84A68A !important
}
.ft-sup-listHead {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}

.ft-inf-left-listHead {
    position: relative;
    border-bottom-left-radius: 10px;
}
.ft-inf-left-listHead::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%; /* Utilise la même largeur que le conteneur */
    height: 100%; /* Utilise la même hauteur que le conteneur */
    border-top-left-radius: 10px;
    border-top: solid 1px #FAB690;
    border-left:  solid 1px #FAB690;
}
.ft-listHead-green.ft-inf-left-listHead::after {
    border-top: solid 1px #9AD3A5;
    border-left:  solid 1px #9AD3A5;
}

.ft-listHead-middle {
    position: relative
}
.ft-listHead-middle::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%; /* Utilise la même largeur que le conteneur */
    height: 100%; /* Utilise la même hauteur que le conteneur */
    border-top: solid 1px #FAB690;
}
.ft-listHead-green.ft-listHead-middle::after {
    border-top: solid 1px #9AD3A5;
}
.ft-inf-right-listHead {
    position:relative;
    border-bottom-right-radius: 10px;
}

.ft-inf-right-listHead::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%; /* Utilise la même largeur que le conteneur */
    height: 100%; /* Utilise la même hauteur que le conteneur */
    border-top-right-radius: 10px;
    border-top: solid 1px #FAB690;
    border-right:  solid 1px #FAB690;
}

.ft-listHead-green.ft-inf-right-listHead::after {
    border-top: solid 1px #9AD3A5;
    border-right:  solid 1px #9AD3A5;
}

.ft-listHead-label {
    font-size: 12px !important;
}

.ft-listHead-visuallyHidden {
    border: 0 !important;
    clip: rect(0 0 0 0) !important;
    height: 1px !important;
    margin: -1px !important;
    overflow: hidden !important;
    padding: 0 !important;
    position: absolute !important;
    top: 20px !important;
    width: 1px !important;
}

.ft-listFilter-divider {
    padding-top: 16px;
}

.ft-modal-paper-title {
    background-color: #fafafa !important;
}

.ft-edit-root {
    padding: 16px;
    margin-bottom: 64px;
}

.ft-justify {
    text-align: justify;
}

.ft-navigation-subNavigation {
    padding-left: 45px !important;
}

.ft-navigation-subSubNavigation {
    padding-left: 65px !important;
}

.ft-container {
    margin-top: 32px !important;
    margin-bottom: 32px !important;
}

/* FT-HEADER */
.ft-header-appBar {
    background-color: #3367d6 !important;
    transition: margin 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms,
    width 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms !important;
    z-index: 1202 !important;
}

.ft-header-appBarShift {
    width: calc(100% - 240px) !important;
    margin-left: 240px !important;
    transition: margin 225ms cubic-bezier(0, 0, 0.2, 1) 0ms,
    width 225ms cubic-bezier(0, 0, 0.2, 1) 0ms !important;
}

.ft-header-menuButton {
    margin-right: 8px !important;
}

.ft-header-hide {
    display: none !important;
}

.ft-header-searchContainer {
    margin-right: 16px !important;
}

.ft-header-translateIcon {
    background-color: white !important;
    color: #3367d6 !important;
    margin-right: 16px !important;
}

.ft-header-fab {
    background-color: white !important;
    color: #3367d6 !important;
    height: 44px !important;
    border-radius: 22px !important;
}

.ft-header-avatar {
    margin-left: 16px !important;
    width: 32px !important;
    height: 32px !important;
}

.ft-header-offset {
    min-height: 56px !important;
}

@media (min-width: 600px) {
    .ft-header-offset {
        min-height: 64px !important;
    }
}

/* FT-LOADING */
.ft-loading-fullHeight {
    min-height: 100vh !important;
}

/* FT-UTILS */
.ft-utils-backdrop {
    color: white !important;
    z-index: 1301 !important;
}

.ft-utils-content {
    flex-grow: 1 !important;
    padding: 24px;
    transition: margin 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms !important;
    margin-left: 0 !important;
    height: calc(100vh - 64px);
    overflow: hidden;
}
.ft-utils-contentBlocked::before {
    position: fixed;
    content: "";
    z-index: 1;
    width: 100%;
    height: 100%;
    /* background-color: rgba(0, 0, 0, 0.5); */
    margin-top: -25px;
}

.ft-utils-contentShift {
    transition: margin 225ms cubic-bezier(0, 0, 0.2, 1) 0ms !important;
    margin-left: 240px !important;
}

/* CROPPER */

.ft-cropper-rounded .cropper-crop-box,
.ft-cropper-rounded .cropper-view-box {
    border-radius: 50%;
}

/* FT-LOGIN */
.ft-login-fullHeight {
    min-height: calc(100vh - 128px) !important;
}

.ft-login-paper {
    padding: 32px !important;
}

.ft-login-marginTop {
    margin-top: 32px !important;
}

.ft-login-marginBottom {
    margin-bottom: 16px !important;
}

/* FT-NAVIGATION */
.ft-navigation {
    width: 240px !important;
    flex-shrink: 0 !important;
}

.ft-navigation-paper {
    width: 240px !important;
    border-right: none !important;
    z-index: 1202 !important;
}

.ft-navigation-header {
    background-color: #3367d6 !important;
    box-shadow: 0 2px 4px -1px rgb(0 0 0 / 20%), 0 4px 5px 0 rgb(0 0 0 / 14%),
    0 1px 10px 0 rgb(0 0 0 / 12%) !important;
    display: flex !important;
    align-items: center !important;
    padding: 0 4px !important;
    justify-content: flex-end !important;
    min-height: 56px !important;
}

.ft-drawer-header {
    display: flex !important;
    align-items: center !important;
    padding: 0 4px !important;
    justify-content: flex-end !important;
}

@media (min-width: 600px) {
    .ft-navigation-header {
        min-height: 64px !important;
    }
}

.ft-navigation-chevronIcon {
    color: white !important;
}

.ft-red-row {
    background-color: rgba(255, 0, 0, 0.5) !important;
}

.ft-red-row:hover {
    background-color: rgba(255, 0, 0, 0.5) !important;
}

.ft-navigation-listContainer {
    border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
    height: 100% !important;
    overflow: hidden;
}

.ft-navigation-subHeader {
    color: #575757 !important;
}

.ft-navigation-active {
    color: #4a75da !important;
}

/* FT-PERMISSIONS */
.ft-permissions-container {
    padding: 16px !important;
}

.ft-permissions-alignCenter {
    text-align: center !important;
}

.ft-permissions-subtitle {
    padding-left: 64px !important;
}

@media (max-width: 900px) {
    .ft-permissions-subtitle {
        padding-left: 32px !important;
    }
}

@media (max-width: 600px) {
    .ft-permissions-subtitle {
        padding-left: 8px !important;
    }
}

/* FT-RESET-PASSWORD */
.ft-resetPassword-marginBottom {
    margin-bottom: 16px !important;
}

.ft-resetPassword-fullHeight {
    min-height: calc(100vh - 128px) !important;
}

.ft-resetPassword-paper {
    padding: 32px !important;
}

.ft-resetPassword-marginTop {
    margin-top: 32px !important;
}

/* FT-USER */
.ft-user-root {
    padding: 16px !important;
    margin-bottom: 64px !important;
}

.ft-user-appBar {
    position: relative !important;
    background-color: #3367d6 !important;
}

.ft-circuit-category-appBar {
    position: relative !important;
    background-color: #3367d6 !important;
}

.ft-user-alignCenter {
    text-align: center !important;
}

.ft-user-container {
    margin-top: 32px !important;
}

.ft-user-title {
    background-color: rgba(0, 0, 0, 0.03) !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125) !important;
}

.ft-user-subContainer {
    padding-top: 16px !important;
}

.ft-user-subtitle {
    padding: 24px !important;
}

.ft-user-subtext {
    padding: 0 24px 24px 24px !important;
}

.ft-user-button {
    margin: 0 24px 16px 24px !important;
    color: #3367d6 !important;
}

.ft-user-info {
    cursor: pointer !important;
}

.ft-user-closeIcon {
    cursor: pointer !important;
}

.ft-user-leftBlock {
    padding: 16px 24px !important;
}

.ft-user-created-appBar {
    position: relative !important;
    background-color: #2e7d32 !important;
}

.ft-user-created-infoPaper {
    padding: 32px !important;
    text-align: center !important;
    margin-bottom: 8px !important;
}

.ft-user-created-mailPaper {
    padding: 32px !important;
    margin-bottom: 8px !important;
}

.ft-user-created-mailIcon {
    font-size: 140px !important;
}

.ft-user-created-licencePaper {
    padding: 16px 32px !important;
    margin-bottom: 8px !important;
    background-color: #e3f2fd !important;
    color: #757575 !important;
}

.ft-user-created-avatar {
    margin: 16px 0 !important;
    width: 60px !important;
    height: 60px !important;
}

.ft-user-created-username {
    font-size: 24px !important;
    margin-bottom: 16px !important;
}

.ft-user-created-subText {
    color: #757575 !important;
}

.ft-user-created-blueText {
    color: #3367d6 !important;
}

.ft-user-created-previewButton {
    margin-left: -6px !important;
}

.ft-user-created-validateButton {
    background-color: #3367d6 !important;
    color: white !important;
    padding: 6px 40px !important;
}

.ft-user-created-passwordDot {
    vertical-align: top !important;
    font-size: 16px !important;
}

.ft-user-createdMax-appBar {
    position: relative !important;
    background-color: #d32f2f !important;
}

.ft-user-createdMax-buttonAgency {
    color: #3367d6 !important;
    margin: 0 0 16px 24px !important;
}

.ft-user-createdMax-button {
    color: #3367d6 !important;
    margin: 0 24px 16px 24px !important;
}

.ft-user-export-paper {
    margin: 16px;
    padding: 16px;
}

.ft-user-delete-buttonContainer {
    margin-top: 8px !important;
}

.ft-user-picture-buttonContainerBottom {
    padding: 0 16px;
    margin-bottom: 16px !important;
}

.ft-circuit-category-icon-buttonContainerBottom {
    padding: 0 16px;
    margin-bottom: 16px !important;
}

.ft-user-delete-button {
    color: white !important;
    background-color: #3367d6 !important;
}

.ft-user-delete-paper {
    margin-top: 32px !important;
}

.ft-user-delete-padding {
    padding: 16px !important;
}

.ft-user-delete-transferInputText,
.ft-user-delete-licenceDivider {
    margin-top: 8px !important;
    margin-bottom: 8px !important;
}

.ft-user-delete-securityIcon {
    font-size: 42px !important;
    color: #42a5f5 !important;
}

.ft-user-editActions-leftBlock {
    padding: 16px !important;
}

.ft-user-editActions-buttonContainer {
    margin-bottom: 16px !important;
}

.ft-user-editActions-button {
    text-align: left !important;
}

.ft-user-editActions-input {
    display: none !important;
}

.ft-user-editAddressContact-infoGrid {
    padding: 8px !important;
    margin: 0 !important;
}

.ft-user-editAddressContact-infoEdit {
    cursor: pointer !important;
}

.ft-user-editAddressContact-infoEdit:hover {
    background-color: #fafafa !important;
}

.ft-user-editAddressContact-subText {
    color: #757575 !important;
    font-size: 12px !important;
}

.ft-user-licenceType-financeAddon {
    margin-top: 8px;
    padding: 4px 12px 10px 4px;
    border: 1px solid #a5d6a7;
    border-radius: 4px;
    background-color: #f1f8e9;
}

.ft-user-licenceType-financeAddonDisabled {
    border-color: #e0e0e0;
    background-color: #fafafa;
}

.ft-user-licenceType-financeAddonHelp {
    display: block !important;
    padding-left: 42px;
    color: #616161 !important;
}

.ft-user-listRow-licenceChip {
    height: 24px !important;
    margin-right: 4px !important;
    border-radius: 12px !important;
    font-weight: 600 !important;
}

.ft-user-listRow-licenceChipDot {
    width: 6px !important;
    height: 6px !important;
    margin-left: 9px !important;
    margin-right: -3px !important;
    border-radius: 50% !important;
}

.ft-user-editAddressContact-editIcon {
    cursor: pointer !important;
    color: rgba(0, 0, 0, 0.54) !important;
}

.ft-user-editAddressContact-buttonContainer {
    text-align: right !important;
    padding: 12px 24px !important;
}

.ft-user-editAddressContact-changeContainer {
    background-color: #e3f2fd !important;
}

.ft-user-editAddressContact-changeSave {
    color: #3367d6 !important;
}

.ft-user-editFolderInfo-subGrid {
    margin-bottom: 16px !important;
    padding: 16px !important;
}

.ft-user-editLeftInfo-role {
    width: fit-content !important;
    padding: 4px 16px !important;
    margin-bottom: 16px !important;
    background-color: #eeeeee !important;
}

.ft-user-editLeftInfo-username {
    font-size: 24px !important;
}

.ft-user-editLeftInfo-userInfo {
    font-size: 12px !important;
    color: #757575 !important;
}

.ft-user-editOrganisation-title {
    font-size: 18px !important;
}

.ft-user-editOrganisation-goBack {
    color: #757575 !important;
}

.ft-user-editOrganisation-titleChevron {
    color: #757575 !important;
    vertical-align: text-top !important;
    font-size: 22px !important;
}

.ft-user-editProfile-subGrid {
    margin-bottom: 16px !important;
    padding: 16px !important;
    cursor: pointer !important;
}
.ft-editPage-subGrid {
    padding: 16px !important;
    cursor: pointer !important;
}

.ft-editPage-Grid-To-Flex {
    display: flex !important;
    gap: 16px  !important;
    margin: 0  !important;
    width: 100%  !important;
}

.ft-user-editProfile-subTitle {
    font-size: 20px !important;
    color: #757575 !important;
    margin-bottom: 16px !important;
}

.ft-user-editProfile-subTest {
    color: #757575 !important;
    font-size: 12px !important;
}

.ft-user-table-font {
    color: #757575 !important;
    font-size: 0.9rem !important;
}

.ft-user-editProfileDeployed-subGrid {
    padding: 16px 16px 0 16px !important;
    background-color: #fafafa !important;
}

.ft-user-editProfileDeployed-closeIcon {
    cursor: pointer !important;
}

.ft-user-editProfileDeployed-subTitle {
    font-size: 20px !important;
    color: #757575 !important;
    margin-bottom: 16px !important;
}

.ft-user-editProfileDeployed-divider {
    margin: 0 -16px !important;
}

.ft-user-editProfileDeployed-gridDivider {
    margin-bottom: 16px !important;
}

.ft-user-editRole-subGrid {
    margin-bottom: 16px !important;
    padding: 16px !important;
    cursor: pointer !important;
}

.ft-user-editRole-subTitle {
    font-size: 20px !important;
    color: #757575 !important;
    margin-bottom: 16px !important;
}

.ft-user-editRole-subText {
    color: #757575 !important;
    font-size: 12px !important;
}

.ft-user-editRole-role {
    margin-bottom: 16px !important;
}

.ft-user-editTitle-title {
    font-size: 24px !important;
    margin-bottom: 16px !important;
}

.ft-user-editTitle-goBack {
    color: #757575 !important;
    cursor: pointer !important;
}

.ft-user-editTitle-titleChevron {
    color: #757575 !important;
    vertical-align: text-top !important;
    font-size: 32px !important;
}

.ft-user-emailPreview-infoPaper {
    padding: 16px !important;
    margin: 16px !important;
    background-color: #eeeeee !important;
}

.ft-user-emailPreview-subText {
    color: #757575 !important;
}

.ft-user-emailPreview-button {
    margin: 0 16px 16px 16px !important;
    color: #3367d6 !important;
}

.ft-user-emailPreview-checkboxContainer {
    margin: 16px 16px 0 16px !important;
}

.ft-user-listFilter-navigation {
    width: 300px !important;
    flex-shrink: 0 !important;
}

.ft-user-listFilter-navigationPaper {
    width: 300px !important;
}

.ft-user-listFilter-closePadding {
    padding: 16px !important;
}

.ft-user-listFilter-inputPadding {
    padding: 16px 16px 0 16px !important;
}

.ft-user-listFilter-resetPadding {
    padding: 16px !important;
}

.ft-lockable-history-drawer {
    width: 400px !important;
    flex-shrink: 0 !important;
}

.ft-lockable-history-drawerPaper {
    width: 400px !important;
}

.ft-list-rootShiftHistory {
    width: calc(100% - 400px) !important;
    transition: width 225ms cubic-bezier(0, 0, 0.2, 1) 0ms !important;
}

.ft-user-listHead-avatar {
    width: 48px !important;
}

.ft-user-listLeftBlock-blockContainer {
    padding: 16px !important;
}

.ft-user-listLeftBlock-sectionHeader {
    cursor: pointer !important;
    user-select: none !important;
}

.ft-user-listLeftBlock-listAll {
    margin-top: 16px !important;
}

.ft-user-listLeftBlock-clientContainer {
    padding: 16px !important;
}

.ft-user-listLeftBlock-divider {
    margin-top: 16px !important;
}

.ft-user-moveOrganisation-button {
    margin: 0 24px 16px 24px !important;
    color: #3367d6 !important;
}

.ft-user-permissions-permissionRootContainer {
    border: 1px solid rgba(0, 0, 0, 0.23) !important;
    margin-top: 16px !important;
    border-radius: 4px !important;
    padding-top: 8px !important;
    padding-bottom: 8px !important;
}

.ft-user-picture-outlined-icon {
    font-size: 335px !important;
    background-color: #eeeeee !important;
}

.ft-circuit-category-icon-outlined-icon {
    font-size: 335px !important;
    background-color: #eeeeee !important;
}

.ft-user-picture-input {
    display: none !important;
}

.ft-circuit-category-icon-input {
    display: none !important;
}

.ft-user-picture-pictureContainer {
    margin-top: 16px !important;
}

.ft-circuit-category-icon-pictureContainer {
    margin-top: 16px !important;
}


.ft-user-picture-buttonContainer {
    padding: 16px !important;
}

.ft-circuit-category-icon-buttonContainer {
    padding: 16px !important;
}

.ft-user-picture-button {
    background-color: white !important;
    color: #3367d6 !important;
}

.ft-user-picture-button:hover {
    background-color: white !important;
}

.ft-circuit-category-icon-button {
    background-color: white !important;
    color: #3367d6 !important;
}

.ft-circuit-category-icon-button:hover {
    background-color: white !important;
}

.ft-circuit-category-picture-button {
    background-color: white !important;
    color: #3367d6 !important;
}

.ft-circuit-category-picture-button:hover {
    background-color: white !important;
}

.ft-user-picture-icon {
    font-size: 56px !important;
    padding: 16px !important;
    background-color: #eeeeee !important;
    border-radius: 50% !important;
    margin-right: 16px !important;
}


.ft-user-picture-error {
    color: #f44336 !important;
    font-size: 12px !important;
    padding: 0 8px !important;
}

.ft-circuit-category-picture-icon {
    font-size: 56px !important;
    padding: 16px !important;
    background-color: #eeeeee !important;
    border-radius: 50% !important;
    margin-right: 16px !important;
}

.ft-circuit-category-picture-error {
    color: #f44336 !important;
    font-size: 12px !important;
    padding: 0 8px !important;
}

.ft-user-search-searchLabel {
    color: white !important;
}

.ft-user-search-searchInput fieldset {
    border-color: white !important;
}

.ft-user-search-searchInput input {
    color: white !important;
}

.ft-user-search-closeIcon {
    cursor: pointer !important;
    color: white !important;
}

/* ROLE */
.ft-role-info {
    cursor: pointer;
    vertical-align: middle;
    margin-left: 8px;
}
/* CIRCUIT TOOLTIP */
.ft-circuit-tooltip-icon {
    cursor: help;
    vertical-align: middle;
    margin-left: 8px;
    font-size: 18px;
    color: rgba(0, 0, 0, 0.54);
}
.ft-error-outline {
    cursor: pointer;
    vertical-align: middle;
    margin-left: 8px;
    color: rgb(255, 68, 0);
}
.ft-error-outline.disabled {
    color: rgb(255, 68, 0, 0.8);
}

/* MARGIN */
.ft-margin-deleteSpacing {
    width: 40px !important;
    height: 40px !important;
}

/* FLIGHT */
.ft-flight-numberCircle {
    border: 1px solid;
    border-radius: 50%;
    padding: 5px 10px;
    margin-right: 8px;
}

.ft-flight-modalButtonContainer {
    margin-bottom: 16px;
}

.ft-flight-segmentSubtitle {
    font-weight: bold !important;
    text-decoration: underline !important;
}

.ft-flight-editSubGrid {
    margin-bottom: 16px !important;
    padding: 16px !important;
}

.ft-flight-statusEmpty {
    color: #ffeb3b !important;
    cursor: pointer !important;
}

.ft-flight-statusPending {
    color: #cc0080 !important;
    cursor: pointer !important;
}

.ft-flight-statusSold {
    color: #4caf50 !important;
    cursor: pointer !important;
}

.ft-flight-statusCancelled {
    color: #ff0000 !important;
    cursor: pointer !important;
}

.ft-accommodation-stock-status-main {
    height: calc(100vh - 64px);
    padding-bottom: 0 !important;
}

.ft-accommodation-stock-status-container {
    display: grid !important;
    grid-template-rows: 141px 104px minmax(0, 1fr) !important;
    height: 100%;
}

.ft-manualFlightFolder-stock {
    padding: 8px !important;
}

.ft-manualFlightFolder-travelerCell {
    font-weight: 500 !important;
}

/* CUSTOM PROVIDER */
.ft-customProvider-contractsCell {
    padding-bottom: 0 !important;
    border-bottom: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
}

/* TRIP */
.ft-trip-dueDate {
    cursor: pointer !important;
}

.ft-trip-dueDateAlarm {
    font-size: 16px !important;
    vertical-align: text-top !important;
    margin-right: 4px !important;
}

.ft-trip-versionRow {
    background-color: #fafafa !important;
}

.ft-trip-filter-status {
    margin-right: 4px;
}

.ft-trip-statusONGOINGvolonline {
    color: #ffeb3b !important;
    cursor: pointer !important;
}

.ft-trip-statusVALIDATEDvolonline {
    color: #FF5F1F !important;
    cursor: pointer !important;
}

.ft-trip-statusUSER_VALIDvolonline {
    color: #8bc34a !important;
    cursor: pointer !important;
}

.ft-trip-statusADDITEMvolonline {
    color: #ed4b82 !important;
    cursor: pointer !important;
}

.ft-trip-statusTOBOOKvolonline {
    color: #673ab7 !important;
    cursor: pointer !important;
}

.ft-trip-statusBOOKEDvolonline {
    color: #4caf50 !important;
    cursor: pointer !important;
}

.ft-trip-statusCANCELLEDvolonline {
    color: #ff0000 !important;
    cursor: pointer !important;
}

.ft-trip-statusONGOING,
.ft-trip-statusQUOTATION,
.ft-trip-statusTRANSMITTED {
    color: #ffeb3b !important;
    cursor: pointer !important;
}

.ft-trip-statusVALIDATED {
    color: #e91e63 !important;
    cursor: pointer !important;
}

.ft-trip-statusAGENCY_MOD {
    color: #757575 !important;
    cursor: pointer !important;
}

.ft-trip-statusTO_UPDATED {
    color: #2c387e !important;
    cursor: pointer !important;
}

.ft-trip-statusUSER_VALID {
    color: #9c27b0 !important;
    cursor: pointer !important;
}

.ft-trip-statusTOBOOK {
    color: #6d1b7b !important;
    cursor: pointer !important;
}

.ft-trip-statusDEPOSIT {
    color: #4caf50 !important;
    cursor: pointer !important;
}

.ft-trip-statusONREQUEST,
.ft-trip-statusFLIGHT_OPTION,
.ft-trip-statusAMENDMENT {
    color: #f44336 !important;
    cursor: pointer !important;
}

.ft-trip-statusBOOKED,
.ft-trip-statusCONFIRMED,
.ft-trip-statusFIXED_PV,
.ft-trip-statusPROCESSED {
    color: #357a38 !important;
    cursor: pointer !important;
}

.ft-trip-statusADDITEM {
    color: #af52bf !important;
    cursor: pointer !important;
}

.ft-trip-statusCLOSED {
    color: #000000 !important;
    cursor: pointer !important;
}

.ft-trip-statusCANCELED,
.ft-trip-statusCANCELLED,
.ft-trip-statusCANCELLED_CDV,
.ft-trip-statusCANCELLED_CGV {
    color: #ff1744 !important;
    cursor: pointer !important;
}

.ft-trip-statusARCHIVED {
    color: #575757 !important;
    cursor: pointer !important;
}

.ft-trip-statusINPROGRESS,
.ft-trip-statusIN_PROGRESS {
    color: #00e5ff !important;
    cursor: pointer !important;
}

.ft-trip-statusFINISHED {
    caret: #2196f3 !important;
    cursor: pointer !important;
}

.ft-trip-arrow {
    color: #575757 !important;
    cursor: pointer !important;
}

/* MANUAL ACCOMMODATION */
.ft-factSearch {
    border: 1px solid #3367d6;
    border-radius: 8px;
}

.ft-factTitle {
    font-size: 24px;
}

.ft-roomBedding {
    position: relative;
}

.ft-roomBeddingTitleContainer {
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    padding: 16px 14px;
    cursor: pointer;
}

.ft-roomBeddingTitleContainerError {
    border-color: #d32f2f;
}

.ft-roomBeddingContainer {
    display: none;
    position: absolute;
    left: 0;
    background-color: white;
    width: 100%;
    z-index: 10;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    padding: 16px 14px;
}

.ft-roomStockCell {
    border-left: 1px solid rgba(224, 224, 224, 1);
    max-width: 70px !important;
}

.ft-legendCell {
    width: 25px;
    height: 25px;
}

.ft-roomStockCellWeekEnd {
    background-color: #eeeeee !important;
}

.ft-roomStockCellNotOnDemand {
    background-color: red !important;
}

.ft-roomStockCellOnDemand {
    background-color: orange !important;
}

.ft-roomStockCellFreelance {
    background-color: #00ff00 !important;
}

.ft-roomStockCellRemainingOnDemand {
    background-color: #2196f3 !important;
    color: white !important;
}

.ft-roomStockCellNoContract {
    cursor: not-allowed;
}

.ft-roomStockCellEdit {
    cursor: pointer;
}

.ft-roomStockCellName {
    background-color: #eeeeee !important;
}

.ft-roomStockAccommodationContractName {
    background-color: transparent !important;
}

.ft-roomStockClosed {
    background-color: #F44336 !important;
}

.ft-roomStockCellClicked {
    background-color: #515151 !important;
}

.ft-roomStockCellHovered {
    filter: contrast(0.5);
}

.ft-roomStockCellBooked {
    color: #cc0080 !important;
    font-weight: bold !important;
}

.ft-roomStockCellWeek {
    white-space: nowrap;
    border-left: 1px solid rgba(224, 224, 224, 1);
}

.ft-roomStockCellSticky {
    white-space: nowrap;
    position: sticky;
    left: 0;
    background-color: white;
    z-index: 100;
}

/* DESTINATION */
.ft-destination-map {
    height: 400px;
}

.ft-destination-ratingHelper {
    font-size: 12px !important;
    color: #3367d6 !important;
}

/* CONNECTED ACTIVITIES */
.ft-connected-activities-map {
    height: 400px;
}

/* @see https://github.com/jpuri/react-draft-wysiwyg/issues/454#issuecomment-943854008 */
.rdw-editor-toolbar.ft-mail-template-visual-editor-text-block-hide-toolbar {
    display: none;
}

.rdw-editor-wrapper:focus-within .ft-mail-template-visual-editor-text-block-hide-toolbar {
    display: flex;
}

.public-DraftStyleDefault-block {
    margin: 0 !important;
}

/* DESTINATION TREE */
.destination-tree-app {
    height: 100%;
}

.destination-tree-treeRoot {
    height: 100%;
    margin-top: 1em;
    list-style: none;
    padding-left: 0;
}

.destination-tree-treeRoot ul {
    list-style: none;
}

.destination-tree-draggingSource {
    opacity: 0.3;
}

.destination-tree-dropTarget {
    background-color: #e8f0fe;
}

.destination-tree-root {
    align-items: center;
    display: grid;
    grid-template-columns: auto auto 1fr auto;
    height: 3.5em;
    margin-bottom: 5px;
}

.destination-tree-root-icon {
    border: #00000070 solid 1px;
    height: 100%;
    width: 3.5em;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: grab;
}

.destination-tree-expandIconWrapper {
    border: #00000070 solid 1px;
    height: 100%;
    width: 3.5em;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-right: none;
    border-left: none;
}

.destination-tree-expandIconWrapper.isOpen {
    transform: rotate(90deg);
    border: #00000070 solid 1px;
    border-top: none;
    border-bottom: none;
}

.destination-tree-labelGridItem {
    border: #00000070 solid 1px;
    height: 100%;
    border-left: none;
    display: flex;
    align-items: center;
}

.destination-tree-info {
    display: flex;
    align-items: center;
}

.flex-center {
    display: flex;
    justify-content: center;
}

.destination-tree-info-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 5px 1em;
}

.destination-tree-info-row p {
    display: flex;
    align-items: center;
    margin: 0;
}

.destination-tree-info-row p span {
    margin-left: 1em;
}

.draggable-tree-item {
    user-drag: none;
    -webkit-user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.draggable-tree-item li {
    user-drag: none;
    -webkit-user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.draggable-tree-item .destination-tree-root-icon {
    pointer-events: none;
}

.draggable-tree-item li .destination-tree-root-icon {
    pointer-events: none;
}


/* CUSTOM CURRENCY */
.inline-form-switch {
    display: flex;
    gap: 10px;
}

.inline-form-switch p {
    align-items: center;
    display: flex;
}

.ft-organisation-main {
    height: calc(100vh - 64px);
    padding: 0 !important;
}

.ft-account-item{
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height:100% !important;
    padding: 37px !important;
    width: 100% !important;
    margin: 0  !important;
    cursor: pointer;
}
.ft-account-item:hover {
    background-color: rgba(32, 149, 242, 0.12);
}


.ft-full-width{
    width: 100% !important;
}
.ft-full-height{
    height: 100% !important;
}

.truncate-container {
    position: relative;
  }

  .truncate-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .truncated {
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
  .ft-iconWidthConfiguration{
    background-color: #3367d6;
    border-radius: 80%;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    opacity: 0.6;
    width: 25px;
    height: 25px;
  }
  .ft-iconWidthConfiguration:hover {
    opacity: 1;
  }

/* INSURANCE PRODUCTS */
.va-extension-document {
    display: flex;
    justify-content: space-between;
}

.va-extension-document>:first-child {
    display: flex;
    gap: 10px;
}

.va-extension-document>:last-child {
    display: flex;
    gap: 30px;
}

.product-extension-header {
    color: #2196F3;
}

.upload-progress {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #00000052;
    z-index: 100;
}

.insurance-price-table-container {
    overflow: auto;
    display: flex;
    gap: 10px;
}

.insurance-price-table-container>div {
    background-color: #d6e1f13d;
    width: 14em;
    min-width: 14em;
    display: flex;
    flex-direction: column;
}

.insurance-price-table-container>div>div {
    padding: 5px;
}

.insurance-price-table-container>div>div p {
    margin: 0;
    font-size: smaller;
}

.insurance-price-table-container>div>:first-child {
    border-bottom: 1px solid #00000038;
    min-height: 8em;
}

.agency-names-container {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 14px;
    color: #c90a0a;
}

.insurance-price-table-container input,
.insurance-price-table-container .MuiSelect-select {
    font-size: small;
    padding: 5px !important;
}

.insurance-price-table-container .MuiInputBase-inputAdornedEnd {
    padding: 7px 5px !important;
}

.insurance-price-table-container .MuiOutlinedInput-root {
    padding: 0px !important;
}

.insurance-price-table-container>div>:last-child {
    background-color: white;
    display: flex;
    align-items: center;
}

.insurance-price-table-container>div>:last-child>div>:last-child {
    margin-bottom: -3px;
}

.insurance-price-table-container>div h4 {
    text-align: center;
    margin: 0;
}

.insurance-price-table-container>:last-child {
    width: 3em;
    min-width: 5em;
    background: none !important;
}

.insurance-price-table-container>:last-child>:first-child {
    border: none;
}

.insurance-price-table-container>div>div>div {
    display: flex;
    justify-content: center;
    padding: 2px;
}

.insurance-price-table-container> :nth-child(even) {
    background-color: #f1d6d63d;
}

.insurance-full-width-price {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1300;
    background-color: white;
    padding: 1em;
    overflow-y: auto;
}

.insurance-full-width-price>:first-child {
    position: relative;
}

.insurance-full-width-price>:first-child .insurance-full-width-price-close-btn {
    position: absolute;
    top: 0;
    right: 0;
}

.document-bank-container {
    margin: 1em 8px;
}

.ft-columnButtonWidhConfiguration{
    position: absolute;
    z-index: 1203 !important;
    left: -20px;
    top: -14px;
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 24px
}

.ft-iconWidthConfiguration {
    background-color: #3367d6;
    border-radius: 80%;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    opacity: 0.6;
    width: 25px;
    height: 25px;
}

  .disabled-cell {
    background-color: #eeeeee;
  }
  .no-padding {
    padding: 0 !important
  }
  .ft-vertical-align {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
  }

.user-detail-actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 1em;
    justify-content: space-around;
}

.user-detail-actions div {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.user-detail-actions p {
    margin: 0;
}


@media (max-width: 1500px) {
    .parameter__name {
        max-width: 25vw !important;
        overflow-wrap: break-word !important
    }
}

.swagger-ui .opblock .opblock-summary-path {
    max-width: none !important
}

.ft-no-margin {
    margin: 0 !important
}

.ft-accounting-title {
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: 48px; 
    margin: 0;
}
.ft-accounting-sub-title {
    font-size: 30px;
    font-weight: 500;
    line-height: 48px;
    margin: 0;
}
.ft-accounting-sub-title-background {
    background: #F6F3F3;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    padding: 10px 35px;
    width: calc(100% + 44px) !important;
    margin-left: -24px;
}

.ft-accounting-text-menu {
    color:#252C32  !important;
    text-align: center;
    text-transform: none !important;
    font-size: 14px; 
    font-weight: 400;
    line-height: 24px;
    border-radius: 0px !important; 
    min-width: 150px !important;
}

.ft-invoice-text-menu {
    color:#252C32  !important;
    text-align: center;
    text-transform: none !important;
    font-size: 14px; 
    font-weight: 400;
    line-height: 24px;
    border-radius: 0px !important; 
    min-width: 0px !important;
}

.ft-accounting-text-menu-selected {
    font-weight: 600 !important;
    border-bottom: solid 3px #3367d6  !important;
    min-width: 150px !important;
}

.ft-account-provider-sub-sub-text {
    color: #828282;
    text-align: right;
    font-size: 8px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 300% */
}

.ft-account-provider-box-money {
    color: #FFF;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 171.429% */
}
.ft-account-provider-box-text {
    color: #FFF;
    font-size: 8px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 300% */
}

.ft-list-header-label-blue {
    color: #4A75DA !important
}

.ft-flex-column {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
}
.ft-flex-row {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;
}

.ft-edit-list-row {
    -webkit-box-shadow: 0px 6px 12px 0px rgba(0,0,0,0.75);
    -moz-box-shadow: 0px 6px 12px 0px rgba(0,0,0,0.75);
    box-shadow: 0px 6px 12px 0px rgba(0,0,0,0.75);
}

.ft-accounting-total {
    display: flex;
    justify-content: space-between;
    gap: 10px;
}

.ft-accounting-total>div {
    font-size: 1rem;
    font-weight: 600;
}

.ft-accounting-total>a {
    text-decoration: none;
    color: #3367d6
}

.ft-accounting-total> span {
    display: flex;
    justify-content: flex-end;
    font-size: 0.9rem;
}

.ft-mini-table-cell {
    padding: 5px !important
}

.ft-over {
    border-bottom: 1px solid #3367d6
}

.ft-over {
    opacity: 0.5
}

.ft-sales-sender-form-edit {
    gap: 7px;
    display: flex;
    flex-direction: column;
    width: 100%;
}

.ft-list-header-sticky {
    position: sticky; 
    top: -3px; 
    background-color: white; 
    z-index: 2; 
    border-bottom: '1px solid rgba(224, 224, 224, 1)';
    -webkit-box-shadow: 0px 1px 0px 0.5px rgba(0,0,0,0.10);
    -moz-box-shadow: 0px 1px 0px 0.5px rgba(0,0,0,0.10);
    box-shadow: 0px 1px 0px 0.5px rgba(0,0,0,0.10);
}

.ft-list-accounting-action-header-sticky {
    position: sticky;
    top: 0;
    z-index: 3;
    background-color: white; 
}
.ft-list-accounting-header-sticky {
    position: sticky; 
    top: 45px; 
    background-color: white; 
    z-index: 2; 
    border-bottom: '1px solid rgba(224, 224, 224, 1)';
    -webkit-box-shadow: 0px 1px 0px 0.5px rgba(0,0,0,0.10);
    -moz-box-shadow: 0px 1px 0px 0.5px rgba(0,0,0,0.10);
    box-shadow: 0px 1px 0px 0.5px rgba(0,0,0,0.10);
}

.ft-list-collection-header-sticky {
    position: sticky; 
    top: -1px; 
    background-color: white; 
    z-index: 2; 
    border-bottom: '1px solid rgba(224, 224, 224, 1)';
    -webkit-box-shadow: 0px 1px 0px 0.5px rgba(0,0,0,0.10);
    -moz-box-shadow: 0px 1px 0px 0.5px rgba(0,0,0,0.10);
    box-shadow: 0px 1px 0px 0.5px rgba(0,0,0,0.10);

}

.ft-accounting-main{
    height: calc(100vh - 64px);
    overflow: hidden;
    padding: 0;
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-bottom: 0 !important;
}

.ft-padding-0 {
    padding: 1.5px 0 !important;
}

.ft-accounting-stat-container {
    display: flex; 
    flex-direction: row; 
    width: '100%';
    gap:5px
}

.ft-accounting-stat-container> div {
    flex: 1;
}

.ft-accounting-stat-amount {
    font-size: 20px;
    font-weight: 700;
    padding-bottom: 4px;
}

.ft-accounting-stat-bar {
    width: 100%;
    height: 24px;
    background: #333;
    border-left: 1px solid white;
    border-radius: 4px;
    transition: transform 0.1s linear;
    margin-top: 10px;
}

.ft-accounting-stat-bar:hover {
    cursor: pointer;
    transform: scaleY(1.3);
    transform-origin: bottom;
    box-shadow: inset 0 -5px 0;
}
.ft-accounting-stat-bar-selected {
    transform: scaleY(1.3);
    transform-origin: bottom;
    box-shadow: inset 0 -5px 0;
}
.ft-accounting-stat-bar-selected:hover {
    transform: scaleY(1.2);
    transform-origin: bottom;
    box-shadow: inset 0 -3px 0;
}

.ft-unbilled {
    background: #0077C5;
    color: #055393;
}
.ft-overdue {
    background: #ff8000;
    color: #f95700;
}


.ft-open {
    background: #BABEC5;
    color: #6b6c72;
}

.ft-paid {
    background: #2ca01c;
    color: #108000;
}

[data-rbd-droppable-id="accounting-export-droppable"]  {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.ft-marketViewItemNoChildren {
    position: relative; 
    z-index: 0;
    padding: 0 10px;
}

.ft-marketViewItemNoChildren:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 0;
    background: #daf0ff;
    transition: width 0.3s ease;
    z-index: -1;
}

.ft-marketViewItemNoChildren:hover:after {
    width: 100%;
}

.ft-marketViewItem {
    position: relative; 
    z-index: 0;
    padding: 0 10px;
}


.ft-marketViewItem:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 0;
    background: #daf0ff;
    transition: width 0.3s ease;
    z-index: -1;
}

.ft-marketViewItem:hover:after {
    width: 100%;
}

.ft-marketViewItem:before {
    content: "";
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
    border-left: 10px solid #daf0ff;
    z-index: 1; 
    opacity: 0; /* Initially hide the arrow */   
    transition: opacity 0.1s ease, right 0.1s ease;
}
.ft-marketViewItem:hover:before {
    transition-delay: 0.3s;
    opacity: 1; /* Show the arrow */
    right: -10px; /* Moves the arrow into place */
}

.ft-marketViewItem:not(:hover):before {
    transition-delay: 0s; /* Add delay for disappearance */
    opacity: 0; /* Hide the arrow */
    right: -10px; /* Move the arrow out of view */
}

.ft-marketViewChecked {
    position: relative;
    z-index: 0;
    padding: 0 10px;
}
.ft-marketViewChecked:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100% !important;
    background: #daf0ff;
    transition: width 0.3s ease;
    z-index: -1;
}

.ft-marketViewHaveChildren {
    position: relative;
    z-index: 0;
    padding: 0 10px;
}

.ft-marketViewHaveChildren:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100% !important;
    background: #daf0ff;
    transition: width 0.3s ease;
    z-index: -1;
}
.ft-marketViewHaveChildren:before {
    content: "";
    position: absolute;
    top: 50%;
    right: -10px !important;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
    border-left: 10px solid #daf0ff;
    z-index: 1;
    opacity: 1 !important; /* Initially hide the arrow */
    transition: opacity 0.1s ease, right 0.1s ease;
}


[data-rich-text="true"] p {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

.new-line {
    content: " ";
    display: block;
    height: 1rem;
}


.richtext-input-adornment-fixed {
    position: absolute;
    right: 10px;
    background: white;
    z-index: 1;
    height: 20px;
    padding: 0 5px;
}

.richtext-input-adornment-fixed {
    position: absolute;
    bottom: -11px;
    right: 10px;
    background: white;
    z-index: 1;
    height: 20px;
    padding: 0 5px;
}

.input-adornment-fixed {
    position: absolute;
    bottom: -11px;
    right: 10px;
    background: white;
    z-index: 1;
    height: 20px;
    padding: 0 5px;
}

.ft-accommodation-stock-disable {
    cursor: initial !important;
}
.ft-room-price-focused > td {
    border-bottom: solid 1.2px rgb(0,0,0,0.3);
    border-top: solid 1.2px rgb(0,0,0,0.3);
}

.ft-editor-container figure {
    margin: 0
}

.dashboard-export-drawer {
    z-index: 1300 !important;
    min-width: 300px;
}


.ft-cms-custom-provider-item {
    box-shadow: inset 4px 0 0 0 #3367d6;
    -webkit-box-shadow: inset 4px 0 0 0 #3367d6;
    -moz-box-shadow: inset 4px 0 0 0 #3367d6;
}
.ft-cms-provider-item {
    box-shadow: inset 4px 0 0 0 teal;
    -webkit-box-shadow: inset 4px 0 0 0 teal;
    -moz-box-shadow: inset 4px 0 0 0 teal;
}`, "",{"version":3,"sources":["webpack://./app/index.css"],"names":[],"mappings":"AAAA,WAAW;AACX;IACI,kCAAkC;AACtC;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;;IAGI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA,WAAW;AACX;IACI,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA,WAAW;AACX;IACI,qCAAqC;IACrC,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,qCAAqC;IACrC,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,SAAS;IACT,OAAO;IACP,qCAAqC;IACrC,kBAAkB;IAClB,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,qCAAqC;IACrC,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,SAAS;IACT,OAAO;IACP,uBAAuB;IACvB,qCAAqC;IACrC,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,0CAA0C;IAC1C,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,0CAA0C;IAC1C,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,QAAQ;IACR,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iCAAiC;AACrC;AACA;IACI,aAAa;IACb,eAAe;IACf;AACJ;AACA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV;AACJ;AACA;IACI,YAAY;IACZ,eAAe;IACf,WAAW;IACX,UAAU;IACV,cAAc;AAClB;AACA;IACI,6BAA6B;IAC7B,4CAA4C;;AAEhD;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,2CAA2C;IAC3C,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI;AACJ;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;IACtB,mEAAmE;AACvE;;AAEA;IACI,oCAAoC;IACpC,iEAAiE;AACrE;;AAEA;IACI,oBAAoB;IACpB,SAAS;IACT,kCAAkC;IAClC,uBAAuB;IACvB,sBAAsB;IACtB,mEAAmE;AACvE;;AAEA;IACI,oCAAoC;IACpC,iEAAiE;AACrE;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,mCAAmC;IACnC,2CAA2C;IAC3C,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;AACxC;;;AAGA;IACI,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB,IAAI,yDAAyD;IAC9E,gBAAgB;IAChB,eAAe;AACnB;;AAEA;qFACqF;AACrF;;;;;;;;;IASI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;AACnC;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW,EAAE,6CAA6C;IAC1D,YAAY,EAAE,6CAA6C;IAC3D,4BAA4B;IAC5B,6BAA6B;IAC7B,+BAA+B;AACnC;AACA;IACI,6BAA6B;IAC7B,+BAA+B;AACnC;;AAEA;IACI;AACJ;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW,EAAE,6CAA6C;IAC1D,YAAY,EAAE,6CAA6C;IAC3D,6BAA6B;AACjC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW,EAAE,6CAA6C;IAC1D,YAAY,EAAE,6CAA6C;IAC3D,6BAA6B;IAC7B,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,qBAAqB;IACrB,6BAA6B;IAC7B,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA,cAAc;AACd;IACI,oCAAoC;IACpC;2DACuD;IACvD,wBAAwB;AAC5B;;AAEA;IACI,oCAAoC;IACpC,6BAA6B;IAC7B;yDACqD;AACzD;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;IACzB,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;IAC5B,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA,eAAe;AACf;IACI,4BAA4B;AAChC;;AAEA,aAAa;AACb;IACI,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,oEAAoE;IACpE,yBAAyB;IACzB,0BAA0B;IAC1B,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,WAAW;IACX,UAAU;IACV,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,iBAAiB;AACrB;;AAEA;IACI,kEAAkE;IAClE,6BAA6B;AACjC;;AAEA,YAAY;;AAEZ;;IAEI,kBAAkB;AACtB;;AAEA,aAAa;AACb;IACI,0CAA0C;AAC9C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;AAClC;;AAEA,kBAAkB;AAClB;IACI,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,wBAAwB;AAC5B;;AAEA;IACI,oCAAoC;IACpC;4CACwC;IACxC,wBAAwB;IACxB,8BAA8B;IAC9B,yBAAyB;IACzB,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,sDAAsD;IACtD,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB;IACI,wBAAwB;AAC5B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,4BAA4B;IAChC;AACJ;;AAEA,sBAAsB;AACtB;IACI,8BAA8B;AAClC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,YAAY;AACZ;IACI,wBAAwB;IACxB,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;IACI,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gDAAgD;IAChD,wDAAwD;AAC5D;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;IACnC,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;IACI,wBAAwB;IACxB,6BAA6B;IAC7B,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;IACxB,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,mCAAmC;AACvC;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;IACvB,oCAAoC;AACxC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;IAC5B,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,2BAA2B;IAC3B,6BAA6B;IAC7B,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,qCAAqC;AACzC;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,wBAAwB;AAC5B;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;IAC5B,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mCAAmC;IACnC,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;IAC9B,wBAAwB;IACxB,0BAA0B;AAC9B;AACA;IACI,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;IACpC,oCAAoC;AACxC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,mCAAmC;IACnC,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,uBAAuB;IACvB,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;IACnC,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,iEAAiE;AACrE;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mCAAmC;IACnC,yBAAyB;AAC7B;;AAEA;IACI,gDAAgD;IAChD,2BAA2B;IAC3B,6BAA6B;IAC7B,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;IAC3B,oCAAoC;AACxC;;AAEA;IACI,2BAA2B;IAC3B,oCAAoC;AACxC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;;AAGA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;IACxB,oCAAoC;IACpC,6BAA6B;IAC7B,6BAA6B;AACjC;;;AAGA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;IACxB,oCAAoC;IACpC,6BAA6B;IAC7B,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA,SAAS;AACT;IACI,eAAe;IACf,sBAAsB;IACtB,gBAAgB;AACpB;AACA,oBAAoB;AACpB;IACI,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,0BAA0B;AAC9B;AACA;IACI,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,2BAA2B;AAC/B;;AAEA,WAAW;AACX;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA,WAAW;AACX;IACI,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,qCAAqC;AACzC;;AAEA;IACI,8BAA8B;IAC9B,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;IACxB,yDAAyD;IACzD,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,oBAAoB;AACpB;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA,SAAS;AACT;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,mCAAmC;IACnC,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;;;IAGI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;;;IAGI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;;;;IAII,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;;;;IAII,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;;IAEI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA,yBAAyB;AACzB;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,uBAAuB;IACvB,WAAW;IACX,WAAW;IACX,qCAAqC;IACrC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,6CAA6C;IAC7C,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,OAAO;IACP,uBAAuB;IACvB,YAAY;AAChB;;AAEA,gBAAgB;AAChB;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA,yBAAyB;AACzB;IACI,aAAa;AACjB;;AAEA,wFAAwF;AACxF;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;AACxB;;AAEA,qBAAqB;AACrB;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;;AAGA,oBAAoB;AACpB;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,wBAAwB;IACxB,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;AACnB;AACA;IACI,0CAA0C;AAC9C;;;AAGA;IACI,sBAAsB;AAC1B;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,4BAA4B;EAC9B;EACA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,YAAY;EACd;EACA;IACE,UAAU;EACZ;;AAEF,uBAAuB;AACvB;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,MAAM;IACN,OAAO;IACP,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,SAAS;AACb;;AAEA;IACI,2BAA2B;IAC3B,WAAW;IACX,eAAe;IACf,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;AACZ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,WAAW;IACX,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;EAEE;IACE,yBAAyB;EAC3B;EACA;IACE;EACF;EACA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;;AAEF;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;IACR,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,SAAS;AACb;;;AAGA;IACI;QACI,0BAA0B;QAC1B;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;AACb;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;AACb;AACA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,4CAA4C;IAC5C,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;AAChC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;AACpC;AACA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;AAChC;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,qDAAqD;IACrD,kDAAkD;IAClD,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,QAAQ;IACR,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,uBAAuB;IACvB,UAAU;IACV,iDAAiD;IACjD,sDAAsD;IACtD,mDAAmD;IACnD,8CAA8C;AAClD;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,uBAAuB;IACvB,UAAU;IACV,iDAAiD;IACjD,sDAAsD;IACtD,mDAAmD;IACnD,8CAA8C;AAClD;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,uBAAuB;IACvB,UAAU;IACV,iDAAiD;IACjD,sDAAsD;IACtD,mDAAmD;IACnD,8CAA8C;;AAElD;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,UAAU;IACV,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,4BAA4B;IAC5B,kBAAkB;IAClB,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,wBAAwB;IACxB,0BAA0B;AAC9B;AACA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,0BAA0B;AAC9B;AACA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;;;AAGA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,QAAQ;IACR,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;AACnB;;;AAGA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,QAAQ;IACR,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,2BAA2B;IAC3B,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,qCAAqC;IACrC,+BAA+B;IAC/B,UAAU;IACV,UAAU,EAAE,6BAA6B;IACzC,8CAA8C;AAClD;AACA;IACI,sBAAsB;IACtB,UAAU,EAAE,mBAAmB;IAC/B,YAAY,EAAE,+BAA+B;AACjD;;AAEA;IACI,oBAAoB,EAAE,gCAAgC;IACtD,UAAU,EAAE,mBAAmB;IAC/B,YAAY,EAAE,+BAA+B;AACjD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;AACnB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;AACf;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,uBAAuB;IACvB,2BAA2B;IAC3B,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,qCAAqC;IACrC,+BAA+B;IAC/B,UAAU;IACV,qBAAqB,EAAE,6BAA6B;IACpD,8CAA8C;AAClD;;;AAGA;IACI,wBAAwB;IACxB,2BAA2B;EAC7B;;AAEF;IACI,YAAY;IACZ,cAAc;IACd,YAAY;AAChB;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,UAAU;IACV,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,UAAU;IACV,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,UAAU;IACV,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;AACA;IACI,yCAAyC;IACzC,sCAAsC;AAC1C;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;AACpB;;;AAGA;IACI,mCAAmC;IACnC,2CAA2C;IAC3C,wCAAwC;AAC5C;AACA;IACI,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;AACzC","sourcesContent":["/* GLOBAL */\r\nbody {\r\n    background-color: white !important;\r\n}\r\n\r\ninput::-webkit-outer-spin-button,\r\ninput::-webkit-inner-spin-button {\r\n    -webkit-appearance: none;\r\n    margin: 0;\r\n}\r\n\r\ninput[type='number'] {\r\n    -moz-appearance: textfield;\r\n}\r\n\r\n::-webkit-scrollbar {\r\n    width: 8px !important;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n    box-shadow: inset 0 0 5px #ddd !important;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n    background: #ddd !important;\r\n    border-radius: 4px !important;\r\n}\r\n\r\n.MuiTableContainer-root::-webkit-scrollbar {\r\n    height: 8px !important;\r\n}\r\n\r\n.ft-blueText {\r\n    color: #3367d6 !important;\r\n}\r\n\r\n.ft-redText {\r\n    color: #d32f2f !important;\r\n}\r\n\r\n.ft-lineBreak {\r\n    white-space: pre-line;\r\n}\r\n\r\n.ft-move {\r\n    cursor: move;\r\n}\r\n\r\n.ft-moving {\r\n    opacity: 0.2;\r\n}\r\n\r\n.ft-iconWarning {\r\n    color: #ed6c02;\r\n}\r\n\r\n.ft-breakWord {\r\n    overflow-wrap: break-word;\r\n}\r\n\r\n.ft-search fieldset {\r\n    border-color: white !important;\r\n}\r\n\r\n.ft-search label,\r\n.ft-search input,\r\n.ft-search svg {\r\n    color: white !important;\r\n}\r\n\r\n.ft-select-box {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 8px;\r\n}\r\n\r\n/* LOCALE */\r\n.ft-locale-check {\r\n    color: green;\r\n    margin-left: 8px;\r\n    font-size: 12px !important;\r\n}\r\n\r\n/* EDITOR */\r\n.ft-editor {\r\n    border: 1px solid rgba(0, 0, 0, 0.12);\r\n    border-radius: 0 0 4px 4px;\r\n    border-top: none;\r\n    padding: 16px 14px;\r\n    min-height: 128px;\r\n    position: relative;\r\n    overflow: hidden;\r\n}\r\n\r\n.ft-editor figure img[style*=\"float: right\"] {\r\n  margin-left: 20px;\r\n}\r\n\r\n.ft-editor figure img[style*=\"float: left\"] {\r\n  margin-right: 20px;\r\n}\r\n\r\n.ft-editorButtonContainer {\r\n    color: rgba(0, 0, 0, 0.54);\r\n    width: fit-content;\r\n    border: 1px solid rgba(0, 0, 0, 0.12);\r\n    border-radius: 4px 4px 0 0;\r\n    background-color: #ffffff;\r\n}\r\n\r\n.ft-editorTextTypeContainer {\r\n    position: relative;\r\n}\r\n\r\n.ft-editorTextType {\r\n    margin-top: 3px !important;\r\n    min-width: 150px;\r\n}\r\n\r\n.ft-editorTextTypeOption {\r\n    cursor: pointer;\r\n    margin: 8px;\r\n}\r\n\r\n.ft-editorTextTypeOptionContainer {\r\n    padding: 8px;\r\n    position: absolute;\r\n    background-color: white;\r\n    top: 41px;\r\n    left: 0;\r\n    border: 1px solid rgba(0, 0, 0, 0.12);\r\n    border-radius: 4px;\r\n    z-index: 2;\r\n    min-width: max-content;\r\n}\r\n\r\n.ft-editorActive {\r\n    color: black !important;\r\n    background-color: #eeeeee !important;\r\n    border-radius: 0 !important;\r\n}\r\n\r\n.ft-editorLinkContainer {\r\n    padding: 16px;\r\n    position: absolute;\r\n    background-color: white;\r\n    top: 41px;\r\n    left: -175px;\r\n    width: 500px;\r\n    border: 1px solid rgba(0, 0, 0, 0.12);\r\n    border-radius: 4px;\r\n    z-index: 1;\r\n}\r\n\r\n.ft-editorPaletteColorContainer {\r\n    padding-bottom: 8px;\r\n    position: absolute;\r\n    background-color: white;\r\n    top: 48px;\r\n    left: 0;\r\n    width: 250px !important;\r\n    border: 1px solid rgba(0, 0, 0, 0.12);\r\n    border-radius: 4px;\r\n    z-index: 2;\r\n}\r\n\r\n.ft-editorPaletteColor {\r\n    border-radius: 4px;\r\n    width: 16px;\r\n    height: 16px;\r\n    cursor: pointer;\r\n}\r\n\r\n.ft-editorPaletteBlack {\r\n    background-color: #000000;\r\n}\r\n\r\n.ft-editorPaletteDarkGray4 {\r\n    background-color: #434343;\r\n}\r\n\r\n.ft-editorPaletteDarkGray3 {\r\n    background-color: #666666;\r\n}\r\n\r\n.ft-editorPaletteDarkGray2 {\r\n    background-color: #999999;\r\n}\r\n\r\n.ft-editorPaletteDarkGray1 {\r\n    background-color: #b7b7b7;\r\n}\r\n\r\n.ft-editorPaletteGray {\r\n    background-color: #cccccc;\r\n}\r\n\r\n.ft-editorPaletteLightGray1 {\r\n    background-color: #d9d9d9;\r\n}\r\n\r\n.ft-editorPaletteLightGray2 {\r\n    background-color: #efefef;\r\n}\r\n\r\n.ft-editorPaletteLightGray3 {\r\n    background-color: #f3f3f3;\r\n}\r\n\r\n.ft-editorPaletteWhite {\r\n    background-color: #ffffff;\r\n}\r\n\r\n.ft-editorPaletteRedBerry {\r\n    background-color: #980000;\r\n}\r\n\r\n.ft-editorPaletteRed {\r\n    background-color: #ff0000;\r\n}\r\n\r\n.ft-editorPaletteOrange {\r\n    background-color: #ff9900;\r\n}\r\n\r\n.ft-editorPaletteYellow {\r\n    background-color: #ffff00;\r\n}\r\n\r\n.ft-editorPaletteGreen {\r\n    background-color: #00ff00;\r\n}\r\n\r\n.ft-editorPaletteCyan {\r\n    background-color: #00ffff;\r\n}\r\n\r\n.ft-editorPaletteCornflowerBlue {\r\n    background-color: #4a86e8;\r\n}\r\n\r\n.ft-editorPaletteBlue {\r\n    background-color: #0000ff;\r\n}\r\n\r\n.ft-editorPalettePurple {\r\n    background-color: #9900ff;\r\n}\r\n\r\n.ft-editorPaletteMagenta {\r\n    background-color: #ff00ff;\r\n}\r\n\r\n.ft-editorPaletteLightRedBerry3 {\r\n    background-color: #e6b8af;\r\n}\r\n\r\n.ft-editorPaletteLightRed3 {\r\n    background-color: #f4cccc;\r\n}\r\n\r\n.ft-editorPaletteLightOrange3 {\r\n    background-color: #fce5cd;\r\n}\r\n\r\n.ft-editorPaletteLightYellow3 {\r\n    background-color: #fff2cc;\r\n}\r\n\r\n.ft-editorPaletteLightGreen3 {\r\n    background-color: #d9ead3;\r\n}\r\n\r\n.ft-editorPaletteLightCyan3 {\r\n    background-color: #d0e0e3;\r\n}\r\n\r\n.ft-editorPaletteLightCornflowerBlue3 {\r\n    background-color: #c9daf8;\r\n}\r\n\r\n.ft-editorPaletteLightBlue3 {\r\n    background-color: #cfe2f3;\r\n}\r\n\r\n.ft-editorPaletteLightPurple3 {\r\n    background-color: #d9d2e9;\r\n}\r\n\r\n.ft-editorPaletteLightMagenta3 {\r\n    background-color: #ead1dc;\r\n}\r\n\r\n.ft-editorPaletteLightRedBerry2 {\r\n    background-color: #dd7e6b;\r\n}\r\n\r\n.ft-editorPaletteLightRed2 {\r\n    background-color: #ea9999;\r\n}\r\n\r\n.ft-editorPaletteLightOrange2 {\r\n    background-color: #f9cb9c;\r\n}\r\n\r\n.ft-editorPaletteLightYellow2 {\r\n    background-color: #ffe599;\r\n}\r\n\r\n.ft-editorPaletteLightGreen2 {\r\n    background-color: #b6d7a8;\r\n}\r\n\r\n.ft-editorPaletteLightCyan2 {\r\n    background-color: #a2c4c9;\r\n}\r\n\r\n.ft-editorPaletteLightCornflowerBlue2 {\r\n    background-color: #a4c2f4;\r\n}\r\n\r\n.ft-editorPaletteLightBlue2 {\r\n    background-color: #9fc5e8;\r\n}\r\n\r\n.ft-editorPaletteLightPurple2 {\r\n    background-color: #b4a7d6;\r\n}\r\n\r\n.ft-editorPaletteLightMagenta2 {\r\n    background-color: #d5a6bd;\r\n}\r\n\r\n.ft-editorPaletteLightRedBerry1 {\r\n    background-color: #cc4125;\r\n}\r\n\r\n.ft-editorPaletteLightRed1 {\r\n    background-color: #e06666;\r\n}\r\n\r\n.ft-editorPaletteLightOrange1 {\r\n    background-color: #f6b26b;\r\n}\r\n\r\n.ft-editorPaletteLightYellow1 {\r\n    background-color: #ffd966;\r\n}\r\n\r\n.ft-editorPaletteLightGreen1 {\r\n    background-color: #93c47d;\r\n}\r\n\r\n.ft-editorPaletteLightCyan1 {\r\n    background-color: #76a5af;\r\n}\r\n\r\n.ft-editorPaletteLightCornflowerBlue1 {\r\n    background-color: #6d9eeb;\r\n}\r\n\r\n.ft-editorPaletteLightBlue1 {\r\n    background-color: #6fa8dc;\r\n}\r\n\r\n.ft-editorPaletteLightPurple1 {\r\n    background-color: #8e7cc3;\r\n}\r\n\r\n.ft-editorPaletteLightMagenta1 {\r\n    background-color: #c27ba0;\r\n}\r\n\r\n.ft-editorPaletteDarkRedBerry1 {\r\n    background-color: #a61c00;\r\n}\r\n\r\n.ft-editorPaletteDarkRed1 {\r\n    background-color: #cc0000;\r\n}\r\n\r\n.ft-editorPaletteDarkOrange1 {\r\n    background-color: #e69138;\r\n}\r\n\r\n.ft-editorPaletteDarkYellow1 {\r\n    background-color: #f1c232;\r\n}\r\n\r\n.ft-editorPaletteDarkGreen1 {\r\n    background-color: #6aa84f;\r\n}\r\n\r\n.ft-editorPaletteDarkCyan1 {\r\n    background-color: #45818e;\r\n}\r\n\r\n.ft-editorPaletteDarkCornflowerBlue1 {\r\n    background-color: #3c78d8;\r\n}\r\n\r\n.ft-editorPaletteDarkBlue1 {\r\n    background-color: #3d85c6;\r\n}\r\n\r\n.ft-editorPaletteDarkPurple1 {\r\n    background-color: #674ea7;\r\n}\r\n\r\n.ft-editorPaletteDarkMagenta1 {\r\n    background-color: #a64d79;\r\n}\r\n\r\n.ft-editorPaletteDarkRedBerry2 {\r\n    background-color: #85200c;\r\n}\r\n\r\n.ft-editorPaletteDarkRed2 {\r\n    background-color: #990000;\r\n}\r\n\r\n.ft-editorPaletteDarkOrange2 {\r\n    background-color: #b45f06;\r\n}\r\n\r\n.ft-editorPaletteDarkYellow2 {\r\n    background-color: #bf9000;\r\n}\r\n\r\n.ft-editorPaletteDarkGreen2 {\r\n    background-color: #38761d;\r\n}\r\n\r\n.ft-editorPaletteDarkCyan2 {\r\n    background-color: #134f5c;\r\n}\r\n\r\n.ft-editorPaletteDarkCornflowerBlue2 {\r\n    background-color: #1155cc;\r\n}\r\n\r\n.ft-editorPaletteDarkBlue2 {\r\n    background-color: #0b5394;\r\n}\r\n\r\n.ft-editorPaletteDarkPurple2 {\r\n    background-color: #351c75;\r\n}\r\n\r\n.ft-editorPaletteDarkMagenta2 {\r\n    background-color: #741b47;\r\n}\r\n\r\n.ft-editorPaletteDarkRedBerry3 {\r\n    background-color: #5b0f00;\r\n}\r\n\r\n.ft-editorPaletteDarkRed3 {\r\n    background-color: #660000;\r\n}\r\n\r\n.ft-editorPaletteDarkOrange3 {\r\n    background-color: #783f04;\r\n}\r\n\r\n.ft-editorPaletteDarkYellow3 {\r\n    background-color: #7f6000;\r\n}\r\n\r\n.ft-editorPaletteDarkGreen3 {\r\n    background-color: #274e13;\r\n}\r\n\r\n.ft-editorPaletteDarkCyan3 {\r\n    background-color: #0c343d;\r\n}\r\n\r\n.ft-editorPaletteDarkCornflowerBlue3 {\r\n    background-color: #1c4587;\r\n}\r\n\r\n.ft-editorPaletteDarkBlue3 {\r\n    background-color: #073763;\r\n}\r\n\r\n.ft-editorPaletteDarkPurple3 {\r\n    background-color: #20124d;\r\n}\r\n\r\n.ft-editorPaletteDarkMagenta3 {\r\n    background-color: #4c1130;\r\n}\r\n\r\n.ft-editorCustomButton {\r\n    width: fit-content !important;\r\n    font-size: 18px !important;\r\n    font-weight: bold !important;\r\n}\r\n\r\n.ft-underline {\r\n    text-decoration: underline;\r\n}\r\n\r\n.ft-bold {\r\n    font-weight: bold;\r\n}\r\n\r\n.ft-hide {\r\n    display: none !important;\r\n}\r\n\r\n.ft-map {\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n}\r\n\r\n.ft-pictureProgress {\r\n    background-color: inherit !important;\r\n    box-shadow: none !important;\r\n}\r\n\r\n.ft-pictureProgressHelper {\r\n    text-align: center !important;\r\n    color: white !important;\r\n    margin-top: 8px !important;\r\n}\r\n\r\n.ft-opaqueImage {\r\n    opacity: 0.2;\r\n}\r\n\r\n.ft-organisation-info-value {\r\n    color: #757575 !important;\r\n    font-size: 0.8rem !important;\r\n}\r\n\r\n.ft-organisation-edit-info-button {\r\n    visibility: hidden;\r\n    cursor: pointer;\r\n}\r\n\r\n.ft-organisation-info-container:hover .ft-organisation-edit-info-button {\r\n    visibility: visible;\r\n}\r\n.ft-organisation-info-container {\r\n    padding-top: 0 !important;\r\n}\r\n\r\n.ft-organisation-column{\r\n    height: calc(100vh - 64px) !important;\r\n    overflow-y: scroll;\r\n}\r\n\r\n.ft-organisation-tab-content {\r\n    height: calc(100% - 49px);\r\n    padding: 0 !important;\r\n    overflow-y: auto;\r\n}\r\n\r\n.ft-organisation-tab-container {\r\n    display: grid;\r\n    height: 100%;\r\n    width: 100%;\r\n    grid-template-rows: 52px minmax(0, 1fr)\r\n}\r\n\r\n.ft-organisation-tab-container-activity{\r\n    display: flex;\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n.ft-organisation-modal{\r\n    position: absolute;\r\n    width: 40vw;\r\n    /* max-height: 20vw; */\r\n    z-index: 2;\r\n    bottom: 25px\r\n}\r\n\r\n.ft-organisation-list-item-detail {\r\n    width: 100%;\r\n    padding: 3px;\r\n    display: grid;\r\n    grid-template-columns: minmax(0, 1fr) 40px;\r\n    align-items: center;\r\n    padding: 5px 20px;\r\n    cursor: pointer;\r\n}\r\n\r\n.ft-organisation-contact {\r\n    width: 100%;\r\n    padding: 10px ;\r\n    border: solid 1px #efefef;\r\n    border-radius: 5px;\r\n    display: grid;\r\n    grid-template-columns: minmax(0, 1fr) 40px;\r\n    align-items: flex-start;\r\n}\r\n\r\n.ft-organisation-list-item-edit-icon {\r\n    display: none;\r\n}\r\n\r\n.ft-organisation-list-item-detail:hover {\r\n    background-color: #c0e0ff;\r\n    border: solid 1px #1976d2;\r\n    border-radius: 10px;\r\n}\r\n\r\n.ft-organisation-contact:hover .ft-organisation-list-item-edit-icon {\r\n    display: block;\r\n    cursor: pointer;\r\n    padding: 0px 10px;\r\n}\r\n\r\n.ft-organisation-list-item-detail:hover .ft-organisation-list-item-edit-icon {\r\n    display: block;\r\n    cursor: pointer;\r\n    padding: 0px 10px;\r\n}\r\n.ft-organisation-item-paper{\r\n    width: 100%;\r\n    padding: 16px;\r\n    margin-bottom: 10px\r\n}\r\n\r\n.ft-organisation-item-delete-icon {\r\n    opacity: 0;\r\n    cursor: pointer;\r\n}\r\n\r\n.ft-organisation-item-paper:hover .ft-organisation-item-delete-icon {\r\n    opacity: 1;\r\n}\r\n\r\n.ft-organisation-form-edit {\r\n    gap: 7px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n}\r\n\r\n.ft-organisation-modal-header {\r\n    max-height: 55px !important;\r\n    min-height: 55px !important;\r\n    height: 55x;\r\n}\r\n\r\n.ft-organisation-logo-container {\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: column !important;\r\n}\r\n.ft-organisation-logo-text{\r\n    display: none;\r\n    font-size: 1rem;\r\n    color: #1976d2\r\n}\r\n.ft-organisation-logo-container:hover .ft-organisation-logo-text{\r\n    display:block;\r\n}\r\n\r\n.ft-organisation-logo-input{\r\n    opacity:0;\r\n    position: absolute;\r\n    height:60px;\r\n    width:60px;\r\n    cursor:pointer\r\n}\r\n.ft-organisation-download-input{\r\n    display:none;\r\n    position: fixed;\r\n    height:24px;\r\n    width:24px;\r\n    cursor:pointer;\r\n}\r\n.ft-organisation-rubric{\r\n    margin-bottom: 5px !important;\r\n    border-bottom: solid 1px rgba(0, 0, 0, 0.12);\r\n    ;\r\n}\r\n\r\n.ft-organisation-rubric-header-icon {\r\n    opacity: 0;\r\n    cursor: move;\r\n    /* fallback if grab cursor is unsupported */\r\n    cursor: grab;\r\n    cursor: -moz-grab;\r\n    cursor: -webkit-grab;\r\n    height: 24px;\r\n    width: 19px;\r\n    transition: none !important;\r\n    will-change: opacity;\r\n}\r\n\r\n.ft-organisation-rubric-header:hover .ft-organisation-rubric-header-icon {\r\n    opacity: 1\r\n}\r\n.ft-organisation-rubric-header{\r\n    min-height: 0 !important;\r\n}\r\n.ft-rotate180 {\r\n    transform: rotate(180deg);\r\n}\r\n\r\n.ft-padding {\r\n    padding: 16px !important;\r\n}\r\n\r\n.ft-marginTop8 {\r\n    margin-top: 8px !important;\r\n}\r\n\r\n.ft-list-root {\r\n    width: 100% !important;\r\n    transition: width 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms !important;\r\n}\r\n\r\n.ft-list-rootShift {\r\n    width: calc(100% - 300px) !important;\r\n    transition: width 225ms cubic-bezier(0, 0, 0.2, 1) 0ms !important;\r\n}\r\n\r\n.ft-bottomBar {\r\n    top: auto !important;\r\n    bottom: 0;\r\n    background-color: white !important;\r\n    color: black !important;\r\n    width: 100% !important;\r\n    transition: width 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms !important;\r\n}\r\n\r\n.ft-bottomBarShift {\r\n    width: calc(100% - 240px) !important;\r\n    transition: width 225ms cubic-bezier(0, 0, 0.2, 1) 0ms !important;\r\n}\r\n\r\n.ft-list-paper {\r\n    position: relative !important;\r\n    padding-top: 8px !important;\r\n}\r\n\r\n.ft-list-title {\r\n    font-size: 18px !important;\r\n    font-weight: bold !important;\r\n    margin-bottom: 16px !important;\r\n}\r\n\r\n.ft-list-table {\r\n    min-width: 750px !important;\r\n}\r\n\r\n.ft-list-listHeaderContainer {\r\n    padding-left: 8px !important;\r\n    padding-right: 4px !important;\r\n}\r\n\r\n.ft-list-listTitle {\r\n    flex: 1 1 100% !important;\r\n}\r\n\r\n.ft-list-blueTextButton {\r\n    text-transform: initial !important;\r\n    color: #3367d6 !important;\r\n}\r\n\r\n.ft-listColumnConfigurator-columnContainer {\r\n    position: absolute !important;\r\n    z-index: 6 !important;\r\n    max-height: 60vh;\r\n    overflow: auto;\r\n}\r\n\r\n.ft-listColumnConfigurator-title {\r\n    padding: 16px !important;\r\n}\r\n\r\n.ft-listColumnConfigurator-column {\r\n    padding: 0 16px !important;\r\n    cursor: grab;\r\n}\r\n\r\n.ft-listColumnConfigurator-lastUpdated {\r\n    background-color: #eeeeee;\r\n}\r\n\r\n.ft-listColumnConfigurator-iconOffset {\r\n    margin-right: 48px !important;\r\n}\r\n\r\n.ft-deleteButton {\r\n    color: #3367d6 !important;\r\n    margin: 0 24px 16px 24px !important;\r\n}\r\n\r\n.ft-newTabIcon {\r\n    margin-left: 8px;\r\n    vertical-align: text-bottom;\r\n    font-size: 18px !important;\r\n}\r\n\r\n.ft-list {\r\n    cursor: pointer;\r\n}\r\n\r\n.ft-listRow-seen {\r\n    background-color: #eeeeee;\r\n    box-shadow: inset 4px 0 0 0 #3367d6;\r\n    -webkit-box-shadow: inset 4px 0 0 0 #3367d6;\r\n    -moz-box-shadow: inset 4px 0 0 0 #3367d6;\r\n}\r\n\r\n.ft-listRow-suspended td {\r\n    color: #cccccc !important;\r\n}\r\n\r\n.ft-listRow-name {\r\n    color: #3367d6 !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-listRow-no-price {\r\n    color: rgb(100, 100, 100) !important;\r\n}\r\n\r\n\r\n.ft-listRow-name:hover {\r\n    text-decoration: underline !important;\r\n}\r\n\r\n.ft-listRow-description {\r\n    max-width: 300px;\r\n    max-height: 2.8em;   /* filet de sécurité : 2 lignes de 1.4em, cf. max_lines */\r\n    overflow: hidden;\r\n    cursor: pointer;\r\n}\r\n\r\n/* Aperçu de liste : on conserve les retours à la ligne enregistrés, un bloc = une ligne,\r\n   tronquée par une ellipsis. Les blocs vides sont retirés en amont (mode compact). */\r\n.ft-listRow-description p,\r\n.ft-listRow-description li,\r\n.ft-listRow-description blockquote,\r\n.ft-listRow-description h1,\r\n.ft-listRow-description h2,\r\n.ft-listRow-description h3,\r\n.ft-listRow-description h4,\r\n.ft-listRow-description h5,\r\n.ft-listRow-description h6 {\r\n    margin: 0;\r\n    font-size: inherit;\r\n    line-height: 1.4;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.ft-listRow-button {\r\n    text-transform: inherit !important;\r\n}\r\n\r\n.ft-listRow-menuItem {\r\n    padding: 16px !important;\r\n}\r\n\r\n.ft-listRow-checkbox {\r\n    width: 74px;\r\n}\r\n\r\n.ft-listHead-minWidth {\r\n    min-width: 256px !important;\r\n}\r\n\r\n.ft-listHead-fixedWidth {\r\n    width: 144px !important;\r\n    overflow-wrap: break-word;\r\n}\r\n.ft-listHead-big {\r\n    text-transform: uppercase;\r\n    color: #4A75DA !important;\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    line-height: 16px;\r\n}\r\n.ft-listHead-other-big {\r\n    text-transform: uppercase;\r\n    color: white !important;\r\n    font-size: 12px;\r\n    font-weight: 700;\r\n    line-height: 16px;\r\n}\r\n\r\n.ft-provisions-background {\r\n    background-color: #E59215 !important\r\n}\r\n.ft-invoices-background {\r\n    background-color: #84A68A !important\r\n}\r\n.ft-sup-listHead {\r\n    border-top-left-radius: 10px;\r\n    border-top-right-radius: 10px;\r\n}\r\n\r\n.ft-inf-left-listHead {\r\n    position: relative;\r\n    border-bottom-left-radius: 10px;\r\n}\r\n.ft-inf-left-listHead::after {\r\n    content: '';\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    width: 100%; /* Utilise la même largeur que le conteneur */\r\n    height: 100%; /* Utilise la même hauteur que le conteneur */\r\n    border-top-left-radius: 10px;\r\n    border-top: solid 1px #FAB690;\r\n    border-left:  solid 1px #FAB690;\r\n}\r\n.ft-listHead-green.ft-inf-left-listHead::after {\r\n    border-top: solid 1px #9AD3A5;\r\n    border-left:  solid 1px #9AD3A5;\r\n}\r\n\r\n.ft-listHead-middle {\r\n    position: relative\r\n}\r\n.ft-listHead-middle::after {\r\n    content: '';\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    width: 100%; /* Utilise la même largeur que le conteneur */\r\n    height: 100%; /* Utilise la même hauteur que le conteneur */\r\n    border-top: solid 1px #FAB690;\r\n}\r\n.ft-listHead-green.ft-listHead-middle::after {\r\n    border-top: solid 1px #9AD3A5;\r\n}\r\n.ft-inf-right-listHead {\r\n    position:relative;\r\n    border-bottom-right-radius: 10px;\r\n}\r\n\r\n.ft-inf-right-listHead::after {\r\n    content: '';\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    width: 100%; /* Utilise la même largeur que le conteneur */\r\n    height: 100%; /* Utilise la même hauteur que le conteneur */\r\n    border-top-right-radius: 10px;\r\n    border-top: solid 1px #FAB690;\r\n    border-right:  solid 1px #FAB690;\r\n}\r\n\r\n.ft-listHead-green.ft-inf-right-listHead::after {\r\n    border-top: solid 1px #9AD3A5;\r\n    border-right:  solid 1px #9AD3A5;\r\n}\r\n\r\n.ft-listHead-label {\r\n    font-size: 12px !important;\r\n}\r\n\r\n.ft-listHead-visuallyHidden {\r\n    border: 0 !important;\r\n    clip: rect(0 0 0 0) !important;\r\n    height: 1px !important;\r\n    margin: -1px !important;\r\n    overflow: hidden !important;\r\n    padding: 0 !important;\r\n    position: absolute !important;\r\n    top: 20px !important;\r\n    width: 1px !important;\r\n}\r\n\r\n.ft-listFilter-divider {\r\n    padding-top: 16px;\r\n}\r\n\r\n.ft-modal-paper-title {\r\n    background-color: #fafafa !important;\r\n}\r\n\r\n.ft-edit-root {\r\n    padding: 16px;\r\n    margin-bottom: 64px;\r\n}\r\n\r\n.ft-justify {\r\n    text-align: justify;\r\n}\r\n\r\n.ft-navigation-subNavigation {\r\n    padding-left: 45px !important;\r\n}\r\n\r\n.ft-navigation-subSubNavigation {\r\n    padding-left: 65px !important;\r\n}\r\n\r\n.ft-container {\r\n    margin-top: 32px !important;\r\n    margin-bottom: 32px !important;\r\n}\r\n\r\n/* FT-HEADER */\r\n.ft-header-appBar {\r\n    background-color: #3367d6 !important;\r\n    transition: margin 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms,\r\n    width 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms !important;\r\n    z-index: 1202 !important;\r\n}\r\n\r\n.ft-header-appBarShift {\r\n    width: calc(100% - 240px) !important;\r\n    margin-left: 240px !important;\r\n    transition: margin 225ms cubic-bezier(0, 0, 0.2, 1) 0ms,\r\n    width 225ms cubic-bezier(0, 0, 0.2, 1) 0ms !important;\r\n}\r\n\r\n.ft-header-menuButton {\r\n    margin-right: 8px !important;\r\n}\r\n\r\n.ft-header-hide {\r\n    display: none !important;\r\n}\r\n\r\n.ft-header-searchContainer {\r\n    margin-right: 16px !important;\r\n}\r\n\r\n.ft-header-translateIcon {\r\n    background-color: white !important;\r\n    color: #3367d6 !important;\r\n    margin-right: 16px !important;\r\n}\r\n\r\n.ft-header-fab {\r\n    background-color: white !important;\r\n    color: #3367d6 !important;\r\n    height: 44px !important;\r\n    border-radius: 22px !important;\r\n}\r\n\r\n.ft-header-avatar {\r\n    margin-left: 16px !important;\r\n    width: 32px !important;\r\n    height: 32px !important;\r\n}\r\n\r\n.ft-header-offset {\r\n    min-height: 56px !important;\r\n}\r\n\r\n@media (min-width: 600px) {\r\n    .ft-header-offset {\r\n        min-height: 64px !important;\r\n    }\r\n}\r\n\r\n/* FT-LOADING */\r\n.ft-loading-fullHeight {\r\n    min-height: 100vh !important;\r\n}\r\n\r\n/* FT-UTILS */\r\n.ft-utils-backdrop {\r\n    color: white !important;\r\n    z-index: 1301 !important;\r\n}\r\n\r\n.ft-utils-content {\r\n    flex-grow: 1 !important;\r\n    padding: 24px;\r\n    transition: margin 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms !important;\r\n    margin-left: 0 !important;\r\n    height: calc(100vh - 64px);\r\n    overflow: hidden;\r\n}\r\n.ft-utils-contentBlocked::before {\r\n    position: fixed;\r\n    content: \"\";\r\n    z-index: 1;\r\n    width: 100%;\r\n    height: 100%;\r\n    /* background-color: rgba(0, 0, 0, 0.5); */\r\n    margin-top: -25px;\r\n}\r\n\r\n.ft-utils-contentShift {\r\n    transition: margin 225ms cubic-bezier(0, 0, 0.2, 1) 0ms !important;\r\n    margin-left: 240px !important;\r\n}\r\n\r\n/* CROPPER */\r\n\r\n.ft-cropper-rounded .cropper-crop-box,\r\n.ft-cropper-rounded .cropper-view-box {\r\n    border-radius: 50%;\r\n}\r\n\r\n/* FT-LOGIN */\r\n.ft-login-fullHeight {\r\n    min-height: calc(100vh - 128px) !important;\r\n}\r\n\r\n.ft-login-paper {\r\n    padding: 32px !important;\r\n}\r\n\r\n.ft-login-marginTop {\r\n    margin-top: 32px !important;\r\n}\r\n\r\n.ft-login-marginBottom {\r\n    margin-bottom: 16px !important;\r\n}\r\n\r\n/* FT-NAVIGATION */\r\n.ft-navigation {\r\n    width: 240px !important;\r\n    flex-shrink: 0 !important;\r\n}\r\n\r\n.ft-navigation-paper {\r\n    width: 240px !important;\r\n    border-right: none !important;\r\n    z-index: 1202 !important;\r\n}\r\n\r\n.ft-navigation-header {\r\n    background-color: #3367d6 !important;\r\n    box-shadow: 0 2px 4px -1px rgb(0 0 0 / 20%), 0 4px 5px 0 rgb(0 0 0 / 14%),\r\n    0 1px 10px 0 rgb(0 0 0 / 12%) !important;\r\n    display: flex !important;\r\n    align-items: center !important;\r\n    padding: 0 4px !important;\r\n    justify-content: flex-end !important;\r\n    min-height: 56px !important;\r\n}\r\n\r\n.ft-drawer-header {\r\n    display: flex !important;\r\n    align-items: center !important;\r\n    padding: 0 4px !important;\r\n    justify-content: flex-end !important;\r\n}\r\n\r\n@media (min-width: 600px) {\r\n    .ft-navigation-header {\r\n        min-height: 64px !important;\r\n    }\r\n}\r\n\r\n.ft-navigation-chevronIcon {\r\n    color: white !important;\r\n}\r\n\r\n.ft-red-row {\r\n    background-color: rgba(255, 0, 0, 0.5) !important;\r\n}\r\n\r\n.ft-red-row:hover {\r\n    background-color: rgba(255, 0, 0, 0.5) !important;\r\n}\r\n\r\n.ft-navigation-listContainer {\r\n    border-right: 1px solid rgba(0, 0, 0, 0.12) !important;\r\n    height: 100% !important;\r\n    overflow: hidden;\r\n}\r\n\r\n.ft-navigation-subHeader {\r\n    color: #575757 !important;\r\n}\r\n\r\n.ft-navigation-active {\r\n    color: #4a75da !important;\r\n}\r\n\r\n/* FT-PERMISSIONS */\r\n.ft-permissions-container {\r\n    padding: 16px !important;\r\n}\r\n\r\n.ft-permissions-alignCenter {\r\n    text-align: center !important;\r\n}\r\n\r\n.ft-permissions-subtitle {\r\n    padding-left: 64px !important;\r\n}\r\n\r\n@media (max-width: 900px) {\r\n    .ft-permissions-subtitle {\r\n        padding-left: 32px !important;\r\n    }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n    .ft-permissions-subtitle {\r\n        padding-left: 8px !important;\r\n    }\r\n}\r\n\r\n/* FT-RESET-PASSWORD */\r\n.ft-resetPassword-marginBottom {\r\n    margin-bottom: 16px !important;\r\n}\r\n\r\n.ft-resetPassword-fullHeight {\r\n    min-height: calc(100vh - 128px) !important;\r\n}\r\n\r\n.ft-resetPassword-paper {\r\n    padding: 32px !important;\r\n}\r\n\r\n.ft-resetPassword-marginTop {\r\n    margin-top: 32px !important;\r\n}\r\n\r\n/* FT-USER */\r\n.ft-user-root {\r\n    padding: 16px !important;\r\n    margin-bottom: 64px !important;\r\n}\r\n\r\n.ft-user-appBar {\r\n    position: relative !important;\r\n    background-color: #3367d6 !important;\r\n}\r\n\r\n.ft-circuit-category-appBar {\r\n    position: relative !important;\r\n    background-color: #3367d6 !important;\r\n}\r\n\r\n.ft-user-alignCenter {\r\n    text-align: center !important;\r\n}\r\n\r\n.ft-user-container {\r\n    margin-top: 32px !important;\r\n}\r\n\r\n.ft-user-title {\r\n    background-color: rgba(0, 0, 0, 0.03) !important;\r\n    border-bottom: 1px solid rgba(0, 0, 0, 0.125) !important;\r\n}\r\n\r\n.ft-user-subContainer {\r\n    padding-top: 16px !important;\r\n}\r\n\r\n.ft-user-subtitle {\r\n    padding: 24px !important;\r\n}\r\n\r\n.ft-user-subtext {\r\n    padding: 0 24px 24px 24px !important;\r\n}\r\n\r\n.ft-user-button {\r\n    margin: 0 24px 16px 24px !important;\r\n    color: #3367d6 !important;\r\n}\r\n\r\n.ft-user-info {\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-user-closeIcon {\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-user-leftBlock {\r\n    padding: 16px 24px !important;\r\n}\r\n\r\n.ft-user-created-appBar {\r\n    position: relative !important;\r\n    background-color: #2e7d32 !important;\r\n}\r\n\r\n.ft-user-created-infoPaper {\r\n    padding: 32px !important;\r\n    text-align: center !important;\r\n    margin-bottom: 8px !important;\r\n}\r\n\r\n.ft-user-created-mailPaper {\r\n    padding: 32px !important;\r\n    margin-bottom: 8px !important;\r\n}\r\n\r\n.ft-user-created-mailIcon {\r\n    font-size: 140px !important;\r\n}\r\n\r\n.ft-user-created-licencePaper {\r\n    padding: 16px 32px !important;\r\n    margin-bottom: 8px !important;\r\n    background-color: #e3f2fd !important;\r\n    color: #757575 !important;\r\n}\r\n\r\n.ft-user-created-avatar {\r\n    margin: 16px 0 !important;\r\n    width: 60px !important;\r\n    height: 60px !important;\r\n}\r\n\r\n.ft-user-created-username {\r\n    font-size: 24px !important;\r\n    margin-bottom: 16px !important;\r\n}\r\n\r\n.ft-user-created-subText {\r\n    color: #757575 !important;\r\n}\r\n\r\n.ft-user-created-blueText {\r\n    color: #3367d6 !important;\r\n}\r\n\r\n.ft-user-created-previewButton {\r\n    margin-left: -6px !important;\r\n}\r\n\r\n.ft-user-created-validateButton {\r\n    background-color: #3367d6 !important;\r\n    color: white !important;\r\n    padding: 6px 40px !important;\r\n}\r\n\r\n.ft-user-created-passwordDot {\r\n    vertical-align: top !important;\r\n    font-size: 16px !important;\r\n}\r\n\r\n.ft-user-createdMax-appBar {\r\n    position: relative !important;\r\n    background-color: #d32f2f !important;\r\n}\r\n\r\n.ft-user-createdMax-buttonAgency {\r\n    color: #3367d6 !important;\r\n    margin: 0 0 16px 24px !important;\r\n}\r\n\r\n.ft-user-createdMax-button {\r\n    color: #3367d6 !important;\r\n    margin: 0 24px 16px 24px !important;\r\n}\r\n\r\n.ft-user-export-paper {\r\n    margin: 16px;\r\n    padding: 16px;\r\n}\r\n\r\n.ft-user-delete-buttonContainer {\r\n    margin-top: 8px !important;\r\n}\r\n\r\n.ft-user-picture-buttonContainerBottom {\r\n    padding: 0 16px;\r\n    margin-bottom: 16px !important;\r\n}\r\n\r\n.ft-circuit-category-icon-buttonContainerBottom {\r\n    padding: 0 16px;\r\n    margin-bottom: 16px !important;\r\n}\r\n\r\n.ft-user-delete-button {\r\n    color: white !important;\r\n    background-color: #3367d6 !important;\r\n}\r\n\r\n.ft-user-delete-paper {\r\n    margin-top: 32px !important;\r\n}\r\n\r\n.ft-user-delete-padding {\r\n    padding: 16px !important;\r\n}\r\n\r\n.ft-user-delete-transferInputText,\r\n.ft-user-delete-licenceDivider {\r\n    margin-top: 8px !important;\r\n    margin-bottom: 8px !important;\r\n}\r\n\r\n.ft-user-delete-securityIcon {\r\n    font-size: 42px !important;\r\n    color: #42a5f5 !important;\r\n}\r\n\r\n.ft-user-editActions-leftBlock {\r\n    padding: 16px !important;\r\n}\r\n\r\n.ft-user-editActions-buttonContainer {\r\n    margin-bottom: 16px !important;\r\n}\r\n\r\n.ft-user-editActions-button {\r\n    text-align: left !important;\r\n}\r\n\r\n.ft-user-editActions-input {\r\n    display: none !important;\r\n}\r\n\r\n.ft-user-editAddressContact-infoGrid {\r\n    padding: 8px !important;\r\n    margin: 0 !important;\r\n}\r\n\r\n.ft-user-editAddressContact-infoEdit {\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-user-editAddressContact-infoEdit:hover {\r\n    background-color: #fafafa !important;\r\n}\r\n\r\n.ft-user-editAddressContact-subText {\r\n    color: #757575 !important;\r\n    font-size: 12px !important;\r\n}\r\n\r\n.ft-user-licenceType-financeAddon {\r\n    margin-top: 8px;\r\n    padding: 4px 12px 10px 4px;\r\n    border: 1px solid #a5d6a7;\r\n    border-radius: 4px;\r\n    background-color: #f1f8e9;\r\n}\r\n\r\n.ft-user-licenceType-financeAddonDisabled {\r\n    border-color: #e0e0e0;\r\n    background-color: #fafafa;\r\n}\r\n\r\n.ft-user-licenceType-financeAddonHelp {\r\n    display: block !important;\r\n    padding-left: 42px;\r\n    color: #616161 !important;\r\n}\r\n\r\n.ft-user-listRow-licenceChip {\r\n    height: 24px !important;\r\n    margin-right: 4px !important;\r\n    border-radius: 12px !important;\r\n    font-weight: 600 !important;\r\n}\r\n\r\n.ft-user-listRow-licenceChipDot {\r\n    width: 6px !important;\r\n    height: 6px !important;\r\n    margin-left: 9px !important;\r\n    margin-right: -3px !important;\r\n    border-radius: 50% !important;\r\n}\r\n\r\n.ft-user-editAddressContact-editIcon {\r\n    cursor: pointer !important;\r\n    color: rgba(0, 0, 0, 0.54) !important;\r\n}\r\n\r\n.ft-user-editAddressContact-buttonContainer {\r\n    text-align: right !important;\r\n    padding: 12px 24px !important;\r\n}\r\n\r\n.ft-user-editAddressContact-changeContainer {\r\n    background-color: #e3f2fd !important;\r\n}\r\n\r\n.ft-user-editAddressContact-changeSave {\r\n    color: #3367d6 !important;\r\n}\r\n\r\n.ft-user-editFolderInfo-subGrid {\r\n    margin-bottom: 16px !important;\r\n    padding: 16px !important;\r\n}\r\n\r\n.ft-user-editLeftInfo-role {\r\n    width: fit-content !important;\r\n    padding: 4px 16px !important;\r\n    margin-bottom: 16px !important;\r\n    background-color: #eeeeee !important;\r\n}\r\n\r\n.ft-user-editLeftInfo-username {\r\n    font-size: 24px !important;\r\n}\r\n\r\n.ft-user-editLeftInfo-userInfo {\r\n    font-size: 12px !important;\r\n    color: #757575 !important;\r\n}\r\n\r\n.ft-user-editOrganisation-title {\r\n    font-size: 18px !important;\r\n}\r\n\r\n.ft-user-editOrganisation-goBack {\r\n    color: #757575 !important;\r\n}\r\n\r\n.ft-user-editOrganisation-titleChevron {\r\n    color: #757575 !important;\r\n    vertical-align: text-top !important;\r\n    font-size: 22px !important;\r\n}\r\n\r\n.ft-user-editProfile-subGrid {\r\n    margin-bottom: 16px !important;\r\n    padding: 16px !important;\r\n    cursor: pointer !important;\r\n}\r\n.ft-editPage-subGrid {\r\n    padding: 16px !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-editPage-Grid-To-Flex {\r\n    display: flex !important;\r\n    gap: 16px  !important;\r\n    margin: 0  !important;\r\n    width: 100%  !important;\r\n}\r\n\r\n.ft-user-editProfile-subTitle {\r\n    font-size: 20px !important;\r\n    color: #757575 !important;\r\n    margin-bottom: 16px !important;\r\n}\r\n\r\n.ft-user-editProfile-subTest {\r\n    color: #757575 !important;\r\n    font-size: 12px !important;\r\n}\r\n\r\n.ft-user-table-font {\r\n    color: #757575 !important;\r\n    font-size: 0.9rem !important;\r\n}\r\n\r\n.ft-user-editProfileDeployed-subGrid {\r\n    padding: 16px 16px 0 16px !important;\r\n    background-color: #fafafa !important;\r\n}\r\n\r\n.ft-user-editProfileDeployed-closeIcon {\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-user-editProfileDeployed-subTitle {\r\n    font-size: 20px !important;\r\n    color: #757575 !important;\r\n    margin-bottom: 16px !important;\r\n}\r\n\r\n.ft-user-editProfileDeployed-divider {\r\n    margin: 0 -16px !important;\r\n}\r\n\r\n.ft-user-editProfileDeployed-gridDivider {\r\n    margin-bottom: 16px !important;\r\n}\r\n\r\n.ft-user-editRole-subGrid {\r\n    margin-bottom: 16px !important;\r\n    padding: 16px !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-user-editRole-subTitle {\r\n    font-size: 20px !important;\r\n    color: #757575 !important;\r\n    margin-bottom: 16px !important;\r\n}\r\n\r\n.ft-user-editRole-subText {\r\n    color: #757575 !important;\r\n    font-size: 12px !important;\r\n}\r\n\r\n.ft-user-editRole-role {\r\n    margin-bottom: 16px !important;\r\n}\r\n\r\n.ft-user-editTitle-title {\r\n    font-size: 24px !important;\r\n    margin-bottom: 16px !important;\r\n}\r\n\r\n.ft-user-editTitle-goBack {\r\n    color: #757575 !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-user-editTitle-titleChevron {\r\n    color: #757575 !important;\r\n    vertical-align: text-top !important;\r\n    font-size: 32px !important;\r\n}\r\n\r\n.ft-user-emailPreview-infoPaper {\r\n    padding: 16px !important;\r\n    margin: 16px !important;\r\n    background-color: #eeeeee !important;\r\n}\r\n\r\n.ft-user-emailPreview-subText {\r\n    color: #757575 !important;\r\n}\r\n\r\n.ft-user-emailPreview-button {\r\n    margin: 0 16px 16px 16px !important;\r\n    color: #3367d6 !important;\r\n}\r\n\r\n.ft-user-emailPreview-checkboxContainer {\r\n    margin: 16px 16px 0 16px !important;\r\n}\r\n\r\n.ft-user-listFilter-navigation {\r\n    width: 300px !important;\r\n    flex-shrink: 0 !important;\r\n}\r\n\r\n.ft-user-listFilter-navigationPaper {\r\n    width: 300px !important;\r\n}\r\n\r\n.ft-user-listFilter-closePadding {\r\n    padding: 16px !important;\r\n}\r\n\r\n.ft-user-listFilter-inputPadding {\r\n    padding: 16px 16px 0 16px !important;\r\n}\r\n\r\n.ft-user-listFilter-resetPadding {\r\n    padding: 16px !important;\r\n}\r\n\r\n.ft-lockable-history-drawer {\r\n    width: 400px !important;\r\n    flex-shrink: 0 !important;\r\n}\r\n\r\n.ft-lockable-history-drawerPaper {\r\n    width: 400px !important;\r\n}\r\n\r\n.ft-list-rootShiftHistory {\r\n    width: calc(100% - 400px) !important;\r\n    transition: width 225ms cubic-bezier(0, 0, 0.2, 1) 0ms !important;\r\n}\r\n\r\n.ft-user-listHead-avatar {\r\n    width: 48px !important;\r\n}\r\n\r\n.ft-user-listLeftBlock-blockContainer {\r\n    padding: 16px !important;\r\n}\r\n\r\n.ft-user-listLeftBlock-sectionHeader {\r\n    cursor: pointer !important;\r\n    user-select: none !important;\r\n}\r\n\r\n.ft-user-listLeftBlock-listAll {\r\n    margin-top: 16px !important;\r\n}\r\n\r\n.ft-user-listLeftBlock-clientContainer {\r\n    padding: 16px !important;\r\n}\r\n\r\n.ft-user-listLeftBlock-divider {\r\n    margin-top: 16px !important;\r\n}\r\n\r\n.ft-user-moveOrganisation-button {\r\n    margin: 0 24px 16px 24px !important;\r\n    color: #3367d6 !important;\r\n}\r\n\r\n.ft-user-permissions-permissionRootContainer {\r\n    border: 1px solid rgba(0, 0, 0, 0.23) !important;\r\n    margin-top: 16px !important;\r\n    border-radius: 4px !important;\r\n    padding-top: 8px !important;\r\n    padding-bottom: 8px !important;\r\n}\r\n\r\n.ft-user-picture-outlined-icon {\r\n    font-size: 335px !important;\r\n    background-color: #eeeeee !important;\r\n}\r\n\r\n.ft-circuit-category-icon-outlined-icon {\r\n    font-size: 335px !important;\r\n    background-color: #eeeeee !important;\r\n}\r\n\r\n.ft-user-picture-input {\r\n    display: none !important;\r\n}\r\n\r\n.ft-circuit-category-icon-input {\r\n    display: none !important;\r\n}\r\n\r\n.ft-user-picture-pictureContainer {\r\n    margin-top: 16px !important;\r\n}\r\n\r\n.ft-circuit-category-icon-pictureContainer {\r\n    margin-top: 16px !important;\r\n}\r\n\r\n\r\n.ft-user-picture-buttonContainer {\r\n    padding: 16px !important;\r\n}\r\n\r\n.ft-circuit-category-icon-buttonContainer {\r\n    padding: 16px !important;\r\n}\r\n\r\n.ft-user-picture-button {\r\n    background-color: white !important;\r\n    color: #3367d6 !important;\r\n}\r\n\r\n.ft-user-picture-button:hover {\r\n    background-color: white !important;\r\n}\r\n\r\n.ft-circuit-category-icon-button {\r\n    background-color: white !important;\r\n    color: #3367d6 !important;\r\n}\r\n\r\n.ft-circuit-category-icon-button:hover {\r\n    background-color: white !important;\r\n}\r\n\r\n.ft-circuit-category-picture-button {\r\n    background-color: white !important;\r\n    color: #3367d6 !important;\r\n}\r\n\r\n.ft-circuit-category-picture-button:hover {\r\n    background-color: white !important;\r\n}\r\n\r\n.ft-user-picture-icon {\r\n    font-size: 56px !important;\r\n    padding: 16px !important;\r\n    background-color: #eeeeee !important;\r\n    border-radius: 50% !important;\r\n    margin-right: 16px !important;\r\n}\r\n\r\n\r\n.ft-user-picture-error {\r\n    color: #f44336 !important;\r\n    font-size: 12px !important;\r\n    padding: 0 8px !important;\r\n}\r\n\r\n.ft-circuit-category-picture-icon {\r\n    font-size: 56px !important;\r\n    padding: 16px !important;\r\n    background-color: #eeeeee !important;\r\n    border-radius: 50% !important;\r\n    margin-right: 16px !important;\r\n}\r\n\r\n.ft-circuit-category-picture-error {\r\n    color: #f44336 !important;\r\n    font-size: 12px !important;\r\n    padding: 0 8px !important;\r\n}\r\n\r\n.ft-user-search-searchLabel {\r\n    color: white !important;\r\n}\r\n\r\n.ft-user-search-searchInput fieldset {\r\n    border-color: white !important;\r\n}\r\n\r\n.ft-user-search-searchInput input {\r\n    color: white !important;\r\n}\r\n\r\n.ft-user-search-closeIcon {\r\n    cursor: pointer !important;\r\n    color: white !important;\r\n}\r\n\r\n/* ROLE */\r\n.ft-role-info {\r\n    cursor: pointer;\r\n    vertical-align: middle;\r\n    margin-left: 8px;\r\n}\r\n/* CIRCUIT TOOLTIP */\r\n.ft-circuit-tooltip-icon {\r\n    cursor: help;\r\n    vertical-align: middle;\r\n    margin-left: 8px;\r\n    font-size: 18px;\r\n    color: rgba(0, 0, 0, 0.54);\r\n}\r\n.ft-error-outline {\r\n    cursor: pointer;\r\n    vertical-align: middle;\r\n    margin-left: 8px;\r\n    color: rgb(255, 68, 0);\r\n}\r\n.ft-error-outline.disabled {\r\n    color: rgb(255, 68, 0, 0.8);\r\n}\r\n\r\n/* MARGIN */\r\n.ft-margin-deleteSpacing {\r\n    width: 40px !important;\r\n    height: 40px !important;\r\n}\r\n\r\n/* FLIGHT */\r\n.ft-flight-numberCircle {\r\n    border: 1px solid;\r\n    border-radius: 50%;\r\n    padding: 5px 10px;\r\n    margin-right: 8px;\r\n}\r\n\r\n.ft-flight-modalButtonContainer {\r\n    margin-bottom: 16px;\r\n}\r\n\r\n.ft-flight-segmentSubtitle {\r\n    font-weight: bold !important;\r\n    text-decoration: underline !important;\r\n}\r\n\r\n.ft-flight-editSubGrid {\r\n    margin-bottom: 16px !important;\r\n    padding: 16px !important;\r\n}\r\n\r\n.ft-flight-statusEmpty {\r\n    color: #ffeb3b !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-flight-statusPending {\r\n    color: #cc0080 !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-flight-statusSold {\r\n    color: #4caf50 !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-flight-statusCancelled {\r\n    color: #ff0000 !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-accommodation-stock-status-main {\r\n    height: calc(100vh - 64px);\r\n    padding-bottom: 0 !important;\r\n}\r\n\r\n.ft-accommodation-stock-status-container {\r\n    display: grid !important;\r\n    grid-template-rows: 141px 104px minmax(0, 1fr) !important;\r\n    height: 100%;\r\n}\r\n\r\n.ft-manualFlightFolder-stock {\r\n    padding: 8px !important;\r\n}\r\n\r\n.ft-manualFlightFolder-travelerCell {\r\n    font-weight: 500 !important;\r\n}\r\n\r\n/* CUSTOM PROVIDER */\r\n.ft-customProvider-contractsCell {\r\n    padding-bottom: 0 !important;\r\n    border-bottom: 0 !important;\r\n    padding-left: 0 !important;\r\n    padding-right: 0 !important;\r\n}\r\n\r\n/* TRIP */\r\n.ft-trip-dueDate {\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-trip-dueDateAlarm {\r\n    font-size: 16px !important;\r\n    vertical-align: text-top !important;\r\n    margin-right: 4px !important;\r\n}\r\n\r\n.ft-trip-versionRow {\r\n    background-color: #fafafa !important;\r\n}\r\n\r\n.ft-trip-filter-status {\r\n    margin-right: 4px;\r\n}\r\n\r\n.ft-trip-statusONGOINGvolonline {\r\n    color: #ffeb3b !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-trip-statusVALIDATEDvolonline {\r\n    color: #FF5F1F !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-trip-statusUSER_VALIDvolonline {\r\n    color: #8bc34a !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-trip-statusADDITEMvolonline {\r\n    color: #ed4b82 !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-trip-statusTOBOOKvolonline {\r\n    color: #673ab7 !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-trip-statusBOOKEDvolonline {\r\n    color: #4caf50 !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-trip-statusCANCELLEDvolonline {\r\n    color: #ff0000 !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-trip-statusONGOING,\r\n.ft-trip-statusQUOTATION,\r\n.ft-trip-statusTRANSMITTED {\r\n    color: #ffeb3b !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-trip-statusVALIDATED {\r\n    color: #e91e63 !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-trip-statusAGENCY_MOD {\r\n    color: #757575 !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-trip-statusTO_UPDATED {\r\n    color: #2c387e !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-trip-statusUSER_VALID {\r\n    color: #9c27b0 !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-trip-statusTOBOOK {\r\n    color: #6d1b7b !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-trip-statusDEPOSIT {\r\n    color: #4caf50 !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-trip-statusONREQUEST,\r\n.ft-trip-statusFLIGHT_OPTION,\r\n.ft-trip-statusAMENDMENT {\r\n    color: #f44336 !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-trip-statusBOOKED,\r\n.ft-trip-statusCONFIRMED,\r\n.ft-trip-statusFIXED_PV,\r\n.ft-trip-statusPROCESSED {\r\n    color: #357a38 !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-trip-statusADDITEM {\r\n    color: #af52bf !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-trip-statusCLOSED {\r\n    color: #000000 !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-trip-statusCANCELED,\r\n.ft-trip-statusCANCELLED,\r\n.ft-trip-statusCANCELLED_CDV,\r\n.ft-trip-statusCANCELLED_CGV {\r\n    color: #ff1744 !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-trip-statusARCHIVED {\r\n    color: #575757 !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-trip-statusINPROGRESS,\r\n.ft-trip-statusIN_PROGRESS {\r\n    color: #00e5ff !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-trip-statusFINISHED {\r\n    caret: #2196f3 !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.ft-trip-arrow {\r\n    color: #575757 !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n/* MANUAL ACCOMMODATION */\r\n.ft-factSearch {\r\n    border: 1px solid #3367d6;\r\n    border-radius: 8px;\r\n}\r\n\r\n.ft-factTitle {\r\n    font-size: 24px;\r\n}\r\n\r\n.ft-roomBedding {\r\n    position: relative;\r\n}\r\n\r\n.ft-roomBeddingTitleContainer {\r\n    border: 1px solid rgba(0, 0, 0, 0.12);\r\n    border-radius: 4px;\r\n    padding: 16px 14px;\r\n    cursor: pointer;\r\n}\r\n\r\n.ft-roomBeddingTitleContainerError {\r\n    border-color: #d32f2f;\r\n}\r\n\r\n.ft-roomBeddingContainer {\r\n    display: none;\r\n    position: absolute;\r\n    left: 0;\r\n    background-color: white;\r\n    width: 100%;\r\n    z-index: 10;\r\n    border: 1px solid rgba(0, 0, 0, 0.12);\r\n    border-radius: 4px;\r\n    padding: 16px 14px;\r\n}\r\n\r\n.ft-roomStockCell {\r\n    border-left: 1px solid rgba(224, 224, 224, 1);\r\n    max-width: 70px !important;\r\n}\r\n\r\n.ft-legendCell {\r\n    width: 25px;\r\n    height: 25px;\r\n}\r\n\r\n.ft-roomStockCellWeekEnd {\r\n    background-color: #eeeeee !important;\r\n}\r\n\r\n.ft-roomStockCellNotOnDemand {\r\n    background-color: red !important;\r\n}\r\n\r\n.ft-roomStockCellOnDemand {\r\n    background-color: orange !important;\r\n}\r\n\r\n.ft-roomStockCellFreelance {\r\n    background-color: #00ff00 !important;\r\n}\r\n\r\n.ft-roomStockCellRemainingOnDemand {\r\n    background-color: #2196f3 !important;\r\n    color: white !important;\r\n}\r\n\r\n.ft-roomStockCellNoContract {\r\n    cursor: not-allowed;\r\n}\r\n\r\n.ft-roomStockCellEdit {\r\n    cursor: pointer;\r\n}\r\n\r\n.ft-roomStockCellName {\r\n    background-color: #eeeeee !important;\r\n}\r\n\r\n.ft-roomStockAccommodationContractName {\r\n    background-color: transparent !important;\r\n}\r\n\r\n.ft-roomStockClosed {\r\n    background-color: #F44336 !important;\r\n}\r\n\r\n.ft-roomStockCellClicked {\r\n    background-color: #515151 !important;\r\n}\r\n\r\n.ft-roomStockCellHovered {\r\n    filter: contrast(0.5);\r\n}\r\n\r\n.ft-roomStockCellBooked {\r\n    color: #cc0080 !important;\r\n    font-weight: bold !important;\r\n}\r\n\r\n.ft-roomStockCellWeek {\r\n    white-space: nowrap;\r\n    border-left: 1px solid rgba(224, 224, 224, 1);\r\n}\r\n\r\n.ft-roomStockCellSticky {\r\n    white-space: nowrap;\r\n    position: sticky;\r\n    left: 0;\r\n    background-color: white;\r\n    z-index: 100;\r\n}\r\n\r\n/* DESTINATION */\r\n.ft-destination-map {\r\n    height: 400px;\r\n}\r\n\r\n.ft-destination-ratingHelper {\r\n    font-size: 12px !important;\r\n    color: #3367d6 !important;\r\n}\r\n\r\n/* CONNECTED ACTIVITIES */\r\n.ft-connected-activities-map {\r\n    height: 400px;\r\n}\r\n\r\n/* @see https://github.com/jpuri/react-draft-wysiwyg/issues/454#issuecomment-943854008 */\r\n.rdw-editor-toolbar.ft-mail-template-visual-editor-text-block-hide-toolbar {\r\n    display: none;\r\n}\r\n\r\n.rdw-editor-wrapper:focus-within .ft-mail-template-visual-editor-text-block-hide-toolbar {\r\n    display: flex;\r\n}\r\n\r\n.public-DraftStyleDefault-block {\r\n    margin: 0 !important;\r\n}\r\n\r\n/* DESTINATION TREE */\r\n.destination-tree-app {\r\n    height: 100%;\r\n}\r\n\r\n.destination-tree-treeRoot {\r\n    height: 100%;\r\n    margin-top: 1em;\r\n    list-style: none;\r\n    padding-left: 0;\r\n}\r\n\r\n.destination-tree-treeRoot ul {\r\n    list-style: none;\r\n}\r\n\r\n.destination-tree-draggingSource {\r\n    opacity: 0.3;\r\n}\r\n\r\n.destination-tree-dropTarget {\r\n    background-color: #e8f0fe;\r\n}\r\n\r\n.destination-tree-root {\r\n    align-items: center;\r\n    display: grid;\r\n    grid-template-columns: auto auto 1fr auto;\r\n    height: 3.5em;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.destination-tree-root-icon {\r\n    border: #00000070 solid 1px;\r\n    height: 100%;\r\n    width: 3.5em;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    cursor: grab;\r\n}\r\n\r\n.destination-tree-expandIconWrapper {\r\n    border: #00000070 solid 1px;\r\n    height: 100%;\r\n    width: 3.5em;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    border-right: none;\r\n    border-left: none;\r\n}\r\n\r\n.destination-tree-expandIconWrapper.isOpen {\r\n    transform: rotate(90deg);\r\n    border: #00000070 solid 1px;\r\n    border-top: none;\r\n    border-bottom: none;\r\n}\r\n\r\n.destination-tree-labelGridItem {\r\n    border: #00000070 solid 1px;\r\n    height: 100%;\r\n    border-left: none;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.destination-tree-info {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.flex-center {\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.destination-tree-info-row {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 5px 1em;\r\n}\r\n\r\n.destination-tree-info-row p {\r\n    display: flex;\r\n    align-items: center;\r\n    margin: 0;\r\n}\r\n\r\n.destination-tree-info-row p span {\r\n    margin-left: 1em;\r\n}\r\n\r\n.draggable-tree-item {\r\n    user-drag: none;\r\n    -webkit-user-drag: none;\r\n    user-select: none;\r\n    -moz-user-select: none;\r\n    -webkit-user-select: none;\r\n    -ms-user-select: none;\r\n}\r\n\r\n.draggable-tree-item li {\r\n    user-drag: none;\r\n    -webkit-user-drag: none;\r\n    user-select: none;\r\n    -moz-user-select: none;\r\n    -webkit-user-select: none;\r\n    -ms-user-select: none;\r\n}\r\n\r\n.draggable-tree-item .destination-tree-root-icon {\r\n    pointer-events: none;\r\n}\r\n\r\n.draggable-tree-item li .destination-tree-root-icon {\r\n    pointer-events: none;\r\n}\r\n\r\n\r\n/* CUSTOM CURRENCY */\r\n.inline-form-switch {\r\n    display: flex;\r\n    gap: 10px;\r\n}\r\n\r\n.inline-form-switch p {\r\n    align-items: center;\r\n    display: flex;\r\n}\r\n\r\n.ft-organisation-main {\r\n    height: calc(100vh - 64px);\r\n    padding: 0 !important;\r\n}\r\n\r\n.ft-account-item{\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    height:100% !important;\r\n    padding: 37px !important;\r\n    width: 100% !important;\r\n    margin: 0  !important;\r\n    cursor: pointer;\r\n}\r\n.ft-account-item:hover {\r\n    background-color: rgba(32, 149, 242, 0.12);\r\n}\r\n\r\n\r\n.ft-full-width{\r\n    width: 100% !important;\r\n}\r\n.ft-full-height{\r\n    height: 100% !important;\r\n}\r\n\r\n.truncate-container {\r\n    position: relative;\r\n  }\r\n\r\n  .truncate-text {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .truncated {\r\n    display: -webkit-box;\r\n    -webkit-box-orient: vertical;\r\n  }\r\n  .ft-iconWidthConfiguration{\r\n    background-color: #3367d6;\r\n    border-radius: 80%;\r\n    padding: 5px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    opacity: 0.6;\r\n    width: 25px;\r\n    height: 25px;\r\n  }\r\n  .ft-iconWidthConfiguration:hover {\r\n    opacity: 1;\r\n  }\r\n\r\n/* INSURANCE PRODUCTS */\r\n.va-extension-document {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.va-extension-document>:first-child {\r\n    display: flex;\r\n    gap: 10px;\r\n}\r\n\r\n.va-extension-document>:last-child {\r\n    display: flex;\r\n    gap: 30px;\r\n}\r\n\r\n.product-extension-header {\r\n    color: #2196F3;\r\n}\r\n\r\n.upload-progress {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    background-color: #00000052;\r\n    z-index: 100;\r\n}\r\n\r\n.insurance-price-table-container {\r\n    overflow: auto;\r\n    display: flex;\r\n    gap: 10px;\r\n}\r\n\r\n.insurance-price-table-container>div {\r\n    background-color: #d6e1f13d;\r\n    width: 14em;\r\n    min-width: 14em;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.insurance-price-table-container>div>div {\r\n    padding: 5px;\r\n}\r\n\r\n.insurance-price-table-container>div>div p {\r\n    margin: 0;\r\n    font-size: smaller;\r\n}\r\n\r\n.insurance-price-table-container>div>:first-child {\r\n    border-bottom: 1px solid #00000038;\r\n    min-height: 8em;\r\n}\r\n\r\n.agency-names-container {\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n    font-size: 14px;\r\n    color: #c90a0a;\r\n}\r\n\r\n.insurance-price-table-container input,\r\n.insurance-price-table-container .MuiSelect-select {\r\n    font-size: small;\r\n    padding: 5px !important;\r\n}\r\n\r\n.insurance-price-table-container .MuiInputBase-inputAdornedEnd {\r\n    padding: 7px 5px !important;\r\n}\r\n\r\n.insurance-price-table-container .MuiOutlinedInput-root {\r\n    padding: 0px !important;\r\n}\r\n\r\n.insurance-price-table-container>div>:last-child {\r\n    background-color: white;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.insurance-price-table-container>div>:last-child>div>:last-child {\r\n    margin-bottom: -3px;\r\n}\r\n\r\n.insurance-price-table-container>div h4 {\r\n    text-align: center;\r\n    margin: 0;\r\n}\r\n\r\n.insurance-price-table-container>:last-child {\r\n    width: 3em;\r\n    min-width: 5em;\r\n    background: none !important;\r\n}\r\n\r\n.insurance-price-table-container>:last-child>:first-child {\r\n    border: none;\r\n}\r\n\r\n.insurance-price-table-container>div>div>div {\r\n    display: flex;\r\n    justify-content: center;\r\n    padding: 2px;\r\n}\r\n\r\n.insurance-price-table-container> :nth-child(even) {\r\n    background-color: #f1d6d63d;\r\n}\r\n\r\n.insurance-full-width-price {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    z-index: 1300;\r\n    background-color: white;\r\n    padding: 1em;\r\n    overflow-y: auto;\r\n}\r\n\r\n.insurance-full-width-price>:first-child {\r\n    position: relative;\r\n}\r\n\r\n.insurance-full-width-price>:first-child .insurance-full-width-price-close-btn {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n}\r\n\r\n.document-bank-container {\r\n    margin: 1em 8px;\r\n}\r\n\r\n.ft-columnButtonWidhConfiguration{\r\n    position: absolute;\r\n    z-index: 1203 !important;\r\n    left: -20px;\r\n    top: -14px;\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    gap: 24px\r\n}\r\n\r\n.ft-iconWidthConfiguration {\r\n    background-color: #3367d6;\r\n    border-radius: 80%;\r\n    padding: 5px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    opacity: 0.6;\r\n    width: 25px;\r\n    height: 25px;\r\n}\r\n\r\n  .disabled-cell {\r\n    background-color: #eeeeee;\r\n  }\r\n  .no-padding {\r\n    padding: 0 !important\r\n  }\r\n  .ft-vertical-align {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n\r\n.user-detail-actions {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    gap: 1em;\r\n    justify-content: space-around;\r\n}\r\n\r\n.user-detail-actions div {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n}\r\n\r\n.user-detail-actions p {\r\n    margin: 0;\r\n}\r\n\r\n\r\n@media (max-width: 1500px) {\r\n    .parameter__name {\r\n        max-width: 25vw !important;\r\n        overflow-wrap: break-word !important\r\n    }\r\n}\r\n\r\n.swagger-ui .opblock .opblock-summary-path {\r\n    max-width: none !important\r\n}\r\n\r\n.ft-no-margin {\r\n    margin: 0 !important\r\n}\r\n\r\n.ft-accounting-title {\r\n    font-size: 30px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: 48px; \r\n    margin: 0;\r\n}\r\n.ft-accounting-sub-title {\r\n    font-size: 30px;\r\n    font-weight: 500;\r\n    line-height: 48px;\r\n    margin: 0;\r\n}\r\n.ft-accounting-sub-title-background {\r\n    background: #F6F3F3;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    flex-direction: row;\r\n    padding: 10px 35px;\r\n    width: calc(100% + 44px) !important;\r\n    margin-left: -24px;\r\n}\r\n\r\n.ft-accounting-text-menu {\r\n    color:#252C32  !important;\r\n    text-align: center;\r\n    text-transform: none !important;\r\n    font-size: 14px; \r\n    font-weight: 400;\r\n    line-height: 24px;\r\n    border-radius: 0px !important; \r\n    min-width: 150px !important;\r\n}\r\n\r\n.ft-invoice-text-menu {\r\n    color:#252C32  !important;\r\n    text-align: center;\r\n    text-transform: none !important;\r\n    font-size: 14px; \r\n    font-weight: 400;\r\n    line-height: 24px;\r\n    border-radius: 0px !important; \r\n    min-width: 0px !important;\r\n}\r\n\r\n.ft-accounting-text-menu-selected {\r\n    font-weight: 600 !important;\r\n    border-bottom: solid 3px #3367d6  !important;\r\n    min-width: 150px !important;\r\n}\r\n\r\n.ft-account-provider-sub-sub-text {\r\n    color: #828282;\r\n    text-align: right;\r\n    font-size: 8px;\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    line-height: 24px; /* 300% */\r\n}\r\n\r\n.ft-account-provider-box-money {\r\n    color: #FFF;\r\n    font-size: 14px;\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    line-height: 24px; /* 171.429% */\r\n}\r\n.ft-account-provider-box-text {\r\n    color: #FFF;\r\n    font-size: 8px;\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    line-height: 24px; /* 300% */\r\n}\r\n\r\n.ft-list-header-label-blue {\r\n    color: #4A75DA !important\r\n}\r\n\r\n.ft-flex-column {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n}\r\n.ft-flex-row {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    flex-direction: row;\r\n}\r\n\r\n.ft-edit-list-row {\r\n    -webkit-box-shadow: 0px 6px 12px 0px rgba(0,0,0,0.75);\r\n    -moz-box-shadow: 0px 6px 12px 0px rgba(0,0,0,0.75);\r\n    box-shadow: 0px 6px 12px 0px rgba(0,0,0,0.75);\r\n}\r\n\r\n.ft-accounting-total {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    gap: 10px;\r\n}\r\n\r\n.ft-accounting-total>div {\r\n    font-size: 1rem;\r\n    font-weight: 600;\r\n}\r\n\r\n.ft-accounting-total>a {\r\n    text-decoration: none;\r\n    color: #3367d6\r\n}\r\n\r\n.ft-accounting-total> span {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    font-size: 0.9rem;\r\n}\r\n\r\n.ft-mini-table-cell {\r\n    padding: 5px !important\r\n}\r\n\r\n.ft-over {\r\n    border-bottom: 1px solid #3367d6\r\n}\r\n\r\n.ft-over {\r\n    opacity: 0.5\r\n}\r\n\r\n.ft-sales-sender-form-edit {\r\n    gap: 7px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n}\r\n\r\n.ft-list-header-sticky {\r\n    position: sticky; \r\n    top: -3px; \r\n    background-color: white; \r\n    z-index: 2; \r\n    border-bottom: '1px solid rgba(224, 224, 224, 1)';\r\n    -webkit-box-shadow: 0px 1px 0px 0.5px rgba(0,0,0,0.10);\r\n    -moz-box-shadow: 0px 1px 0px 0.5px rgba(0,0,0,0.10);\r\n    box-shadow: 0px 1px 0px 0.5px rgba(0,0,0,0.10);\r\n}\r\n\r\n.ft-list-accounting-action-header-sticky {\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 3;\r\n    background-color: white; \r\n}\r\n.ft-list-accounting-header-sticky {\r\n    position: sticky; \r\n    top: 45px; \r\n    background-color: white; \r\n    z-index: 2; \r\n    border-bottom: '1px solid rgba(224, 224, 224, 1)';\r\n    -webkit-box-shadow: 0px 1px 0px 0.5px rgba(0,0,0,0.10);\r\n    -moz-box-shadow: 0px 1px 0px 0.5px rgba(0,0,0,0.10);\r\n    box-shadow: 0px 1px 0px 0.5px rgba(0,0,0,0.10);\r\n}\r\n\r\n.ft-list-collection-header-sticky {\r\n    position: sticky; \r\n    top: -1px; \r\n    background-color: white; \r\n    z-index: 2; \r\n    border-bottom: '1px solid rgba(224, 224, 224, 1)';\r\n    -webkit-box-shadow: 0px 1px 0px 0.5px rgba(0,0,0,0.10);\r\n    -moz-box-shadow: 0px 1px 0px 0.5px rgba(0,0,0,0.10);\r\n    box-shadow: 0px 1px 0px 0.5px rgba(0,0,0,0.10);\r\n\r\n}\r\n\r\n.ft-accounting-main{\r\n    height: calc(100vh - 64px);\r\n    overflow: hidden;\r\n    padding: 0;\r\n    padding-left: 0 !important;\r\n    padding-right: 0 !important;\r\n    padding-bottom: 0 !important;\r\n}\r\n\r\n.ft-padding-0 {\r\n    padding: 1.5px 0 !important;\r\n}\r\n\r\n.ft-accounting-stat-container {\r\n    display: flex; \r\n    flex-direction: row; \r\n    width: '100%';\r\n    gap:5px\r\n}\r\n\r\n.ft-accounting-stat-container> div {\r\n    flex: 1;\r\n}\r\n\r\n.ft-accounting-stat-amount {\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n    padding-bottom: 4px;\r\n}\r\n\r\n.ft-accounting-stat-bar {\r\n    width: 100%;\r\n    height: 24px;\r\n    background: #333;\r\n    border-left: 1px solid white;\r\n    border-radius: 4px;\r\n    transition: transform 0.1s linear;\r\n    margin-top: 10px;\r\n}\r\n\r\n.ft-accounting-stat-bar:hover {\r\n    cursor: pointer;\r\n    transform: scaleY(1.3);\r\n    transform-origin: bottom;\r\n    box-shadow: inset 0 -5px 0;\r\n}\r\n.ft-accounting-stat-bar-selected {\r\n    transform: scaleY(1.3);\r\n    transform-origin: bottom;\r\n    box-shadow: inset 0 -5px 0;\r\n}\r\n.ft-accounting-stat-bar-selected:hover {\r\n    transform: scaleY(1.2);\r\n    transform-origin: bottom;\r\n    box-shadow: inset 0 -3px 0;\r\n}\r\n\r\n.ft-unbilled {\r\n    background: #0077C5;\r\n    color: #055393;\r\n}\r\n.ft-overdue {\r\n    background: #ff8000;\r\n    color: #f95700;\r\n}\r\n\r\n\r\n.ft-open {\r\n    background: #BABEC5;\r\n    color: #6b6c72;\r\n}\r\n\r\n.ft-paid {\r\n    background: #2ca01c;\r\n    color: #108000;\r\n}\r\n\r\n[data-rbd-droppable-id=\"accounting-export-droppable\"]  {\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n}\r\n\r\n.ft-marketViewItemNoChildren {\r\n    position: relative; \r\n    z-index: 0;\r\n    padding: 0 10px;\r\n}\r\n\r\n.ft-marketViewItemNoChildren:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    height: 100%;\r\n    width: 0;\r\n    background: #daf0ff;\r\n    transition: width 0.3s ease;\r\n    z-index: -1;\r\n}\r\n\r\n.ft-marketViewItemNoChildren:hover:after {\r\n    width: 100%;\r\n}\r\n\r\n.ft-marketViewItem {\r\n    position: relative; \r\n    z-index: 0;\r\n    padding: 0 10px;\r\n}\r\n\r\n\r\n.ft-marketViewItem:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    height: 100%;\r\n    width: 0;\r\n    background: #daf0ff;\r\n    transition: width 0.3s ease;\r\n    z-index: -1;\r\n}\r\n\r\n.ft-marketViewItem:hover:after {\r\n    width: 100%;\r\n}\r\n\r\n.ft-marketViewItem:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 50%;\r\n    right: 0;\r\n    transform: translateY(-50%);\r\n    width: 0;\r\n    height: 0;\r\n    border-top: 20px solid transparent;\r\n    border-bottom: 20px solid transparent;\r\n    border-left: 10px solid #daf0ff;\r\n    z-index: 1; \r\n    opacity: 0; /* Initially hide the arrow */   \r\n    transition: opacity 0.1s ease, right 0.1s ease;\r\n}\r\n.ft-marketViewItem:hover:before {\r\n    transition-delay: 0.3s;\r\n    opacity: 1; /* Show the arrow */\r\n    right: -10px; /* Moves the arrow into place */\r\n}\r\n\r\n.ft-marketViewItem:not(:hover):before {\r\n    transition-delay: 0s; /* Add delay for disappearance */\r\n    opacity: 0; /* Hide the arrow */\r\n    right: -10px; /* Move the arrow out of view */\r\n}\r\n\r\n.ft-marketViewChecked {\r\n    position: relative;\r\n    z-index: 0;\r\n    padding: 0 10px;\r\n}\r\n.ft-marketViewChecked:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    height: 100%;\r\n    width: 100% !important;\r\n    background: #daf0ff;\r\n    transition: width 0.3s ease;\r\n    z-index: -1;\r\n}\r\n\r\n.ft-marketViewHaveChildren {\r\n    position: relative;\r\n    z-index: 0;\r\n    padding: 0 10px;\r\n}\r\n\r\n.ft-marketViewHaveChildren:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    height: 100%;\r\n    width: 100% !important;\r\n    background: #daf0ff;\r\n    transition: width 0.3s ease;\r\n    z-index: -1;\r\n}\r\n.ft-marketViewHaveChildren:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 50%;\r\n    right: -10px !important;\r\n    transform: translateY(-50%);\r\n    width: 0;\r\n    height: 0;\r\n    border-top: 20px solid transparent;\r\n    border-bottom: 20px solid transparent;\r\n    border-left: 10px solid #daf0ff;\r\n    z-index: 1;\r\n    opacity: 1 !important; /* Initially hide the arrow */\r\n    transition: opacity 0.1s ease, right 0.1s ease;\r\n}\r\n\r\n\r\n[data-rich-text=\"true\"] p {\r\n    margin-top: 0 !important;\r\n    margin-bottom: 0 !important;\r\n  }\r\n\r\n.new-line {\r\n    content: \" \";\r\n    display: block;\r\n    height: 1rem;\r\n}\r\n\r\n\r\n.richtext-input-adornment-fixed {\r\n    position: absolute;\r\n    right: 10px;\r\n    background: white;\r\n    z-index: 1;\r\n    height: 20px;\r\n    padding: 0 5px;\r\n}\r\n\r\n.richtext-input-adornment-fixed {\r\n    position: absolute;\r\n    bottom: -11px;\r\n    right: 10px;\r\n    background: white;\r\n    z-index: 1;\r\n    height: 20px;\r\n    padding: 0 5px;\r\n}\r\n\r\n.input-adornment-fixed {\r\n    position: absolute;\r\n    bottom: -11px;\r\n    right: 10px;\r\n    background: white;\r\n    z-index: 1;\r\n    height: 20px;\r\n    padding: 0 5px;\r\n}\r\n\r\n.ft-accommodation-stock-disable {\r\n    cursor: initial !important;\r\n}\r\n.ft-room-price-focused > td {\r\n    border-bottom: solid 1.2px rgb(0,0,0,0.3);\r\n    border-top: solid 1.2px rgb(0,0,0,0.3);\r\n}\r\n\r\n.ft-editor-container figure {\r\n    margin: 0\r\n}\r\n\r\n.dashboard-export-drawer {\r\n    z-index: 1300 !important;\r\n    min-width: 300px;\r\n}\r\n\r\n\r\n.ft-cms-custom-provider-item {\r\n    box-shadow: inset 4px 0 0 0 #3367d6;\r\n    -webkit-box-shadow: inset 4px 0 0 0 #3367d6;\r\n    -moz-box-shadow: inset 4px 0 0 0 #3367d6;\r\n}\r\n.ft-cms-provider-item {\r\n    box-shadow: inset 4px 0 0 0 teal;\r\n    -webkit-box-shadow: inset 4px 0 0 0 teal;\r\n    -moz-box-shadow: inset 4px 0 0 0 teal;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
